// import axios from "axios"; 
// import { useEffect, useRef, useState } from "react";
// import {
//     FiBriefcase,
//     FiCalendar,
//     FiCheckCircle,
//     FiMail,
//     FiAlertTriangle,
//     FiEye,
//     FiFileText,
//     FiMapPin,
//     FiPhone,
//     FiStar,
//     FiX,
//     FiClock,
//     FiTrash2,
//     FiDownload,
//     FiAward,
//     FiUsers,
//     FiUser,
//     FiTrendingUp,
//     FiClipboard,
//     FiFilter,
//     FiSearch
// } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import "./EmployeeDashboard.css";

// const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

// const DetailItem = ({ icon, label, value }) => (
//     <div className="emp-dash__detail-row">
//         <span className="emp-dash__detail-label">{label}</span>
//         <span className="emp-dash__detail-value">{value || "N/A"}</span>
//     </div>
// );

// const Score = () => {
//     const [candidates, setCandidates] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [scoreFilter, setScoreFilter] = useState(0);
//     const [roleFilter, setRoleFilter] = useState("");
//     const [dateFilter, setDateFilter] = useState("");
//     const [statusFilter, setStatusFilter] = useState("");
//     const [statuses, setStatuses] = useState([]);
//     const [roles, setRoles] = useState([]);
//     const [roleSearchQuery, setRoleSearchQuery] = useState("");
//     const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//     const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
//     const [showMobileFilters, setShowMobileFilters] = useState(false);

//     const roleDropdownRef = useRef(null);
//     const statusDropdownRef = useRef(null);
//     const [selectedCandidate, setSelectedCandidate] = useState(null);
//     const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
//     const [inviteForm, setInviteForm] = useState({
//         subject: "Interview Invitation - Timely Health",
//         time: "",
//         interviewMode: "Online",
//         interviewAddress: "", // ✅ FIX: Added interviewAddress
//     });

//     const [locations, setLocations] = useState([]);
//     const [isDocsModalOpen, setIsDocsModalOpen] = useState(false);
//     const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);
//     const [selectedAssessmentData, setSelectedAssessmentData] = useState(null);
//     const [docsForm, setDocsForm] = useState({
//         agreementsContent: "Please read, sign, and re-upload this agreement for next steps.",
//     });
//     const [personalDocs, setPersonalDocs] = useState(null);
//     const [personalDocsLoading, setPersonalDocsLoading] = useState(false);

//     const [quizzes, setQuizzes] = useState([]);

//     const formatDocUrl = (url) => {
//         if (!url) return "";
//         const cleanUrl = url.startsWith("/") ? url : `/${url}`;
//         return `${API_BASE_URL.replace("/api", "")}${cleanUrl.replace(/\\/g, "/")}`;
//     };

//     // Pagination states
//     const [pagination, setPagination] = useState({
//         currentPage: 1,
//         totalPages: 1,
//         totalCount: 0,
//         limit: 10,
//     });

//     const [isPackageModalOpen, setIsPackageModalOpen] = useState(false);
//     const [packageSalary, setPackageSalary] = useState("");
//     const [packageJoiningDate, setPackageJoiningDate] = useState("");
//     const [packageNoticePeriod, setPackageNoticePeriod] = useState("");
//     const [packageProbationPeriod, setPackageProbationPeriod] = useState("");
//     const [packageDailyAllowance, setPackageDailyAllowance] = useState("");
//     const [packagePerformanceAllowance, setPackagePerformanceAllowance] = useState("");
//     const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
//     const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
//     const [historyLoading, setHistoryLoading] = useState(false);

//     const navigate = useNavigate();

//     // Get clientId from localStorage
//     const getClientId = () => {
//         return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
//     };

//     useEffect(() => {
//         fetchCandidates();
//         fetchQuizzes();
//         fetchLocations();
//         fetchRoles();

//         const handleClickOutside = (event) => {
//             if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//                 setIsRoleDropdownOpen(false);
//             }
//             if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
//                 setIsStatusDropdownOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const fetchRoles = async () => {
//         try {
//             const clientId = getClientId();
//             let url;
//             if (clientId) {
//                 url = `${API_BASE_URL}/jobs/all/${clientId}`;
//             } else {
//                 url = `${API_BASE_URL}/jobs/all`;
//             }
//             const res = await axios.get(url);
//             if (res.data.success) {
//                 const rolesData = res.data.jobPosts || [];
//                 const formattedRoles = rolesData.map((job, index) => ({
//                     _id: job._id || index,
//                     name: job.role
//                 }));
//                 const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
//                     .filter(name => name && !name.toLowerCase().includes("resign"))
//                     .map(name => formattedRoles.find(r => r.name === name));
//                 setRoles(uniqueRoles);
//             }
//         } catch (err) {
//             console.error("Failed to fetch roles:", err);
//         }
//     };

//     const fetchLocations = async () => {
//         try {
//             const clientId = getClientId();
//             let url;
//             if (clientId) {
//                 url = `${API_BASE_URL}/location/alllocation?clientId=${clientId}`;
//             } else {
//                 url = `${API_BASE_URL}/location/alllocation`;
//             }
//             const res = await axios.get(url);
//             if (res.data?.locations) setLocations(res.data.locations);
//         } catch (err) {
//             console.error("Failed to fetch locations:", err);
//         }
//     };

//     const fetchQuizzes = async () => {
//         try {
//             const clientId = getClientId();
//             let url;
//             if (clientId) {
//                 url = `${API_BASE_URL}/admin/getallquizes/${clientId}`;
//             } else {
//                 url = `${API_BASE_URL}/admin/getallquizes`;
//             }
//             const res = await axios.get(url);
//             if (res.data?.quizzes) setQuizzes(res.data.quizzes);
//         } catch (err) {
//             console.error("Failed to fetch quizzes:", err);
//         }
//     };

//     const fetchCandidates = async () => {
//         try {
//             setLoading(true);
//             const clientId = getClientId();
//             let url;
//             if (clientId) {
//                 url = `${API_BASE_URL}/applications/all/${clientId}`;
//             } else {
//                 url = `${API_BASE_URL}/applications/all`;
//             }
//             const res = await axios.get(url);
//             if (res.data.success) {
//                 setCandidates(res.data.applications || []);
//             }
//         } catch (err) {
//             setError("Failed to fetch candidates score data");
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleUpdateScore = async (id, field, value) => {
//         const numericValue = (field === "status") ? value : Number(value);
//         const clientId = getClientId();

//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
//                 applicationId: id,
//                 clientId: clientId,
//                 [field]: numericValue,
//             });
//             if (res.data.success) {
//                 setCandidates((prev) =>
//                     prev.map((c) => (c._id === id ? { ...c, [field]: numericValue } : c))
//                 );
//             }
//         } catch (err) {
//             console.error("Update score error:", err);
//         }
//     };

//     const handleOpenInviteModal = (candidate) => {
//         setSelectedCandidate(candidate);
//         setInviteForm({
//             subject: "Interview Invitation - Timely Health",
//             time: "",
//             interviewMode: "Online",
//             interviewAddress: "", // ✅ Reset address
//         });
//         setIsInviteModalOpen(true);
//     };

//     // ✅ FIX: handleSendInvite with interviewAddress
//     const handleSendInvite = async () => {
//         if (!inviteForm.time || !inviteForm.subject) {
//             alert("Please fill in all fields");
//             return;
//         }

//         const clientId = getClientId();

//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/send-invitation`, {
//                 applicationId: selectedCandidate._id,
//                 clientId: clientId,
//                 interviewSubject: inviteForm.subject,
//                 interviewTime: inviteForm.time,
//                 interviewMode: inviteForm.interviewMode,
//                 interviewAddress: inviteForm.interviewAddress, // ✅ FIX: Sending interviewAddress
//             });

//             if (res.data.success) {
//                 alert("Interview invitation sent successfully!");
//                 setIsInviteModalOpen(false);
//                 fetchCandidates();
//             }
//         } catch (err) {
//             console.error("Send invite error:", err);
//             alert("Failed to send invitation");
//         }
//     };

//     const handleOpenOfferModal = (candidate) => {
//         navigate(`/send-offer?id=${candidate._id}&email=${candidate.email}`);
//     };

//     const handleOpenPackageModal = (candidate) => {
//         setSelectedCandidate(candidate);
//         setPackageSalary(candidate.finalSalary || candidate.expectedCTC || "");
//         setPackageJoiningDate(candidate.dateOfJoining || "");
//         setPackageNoticePeriod(candidate.noticePeriod || "");
//         setPackageProbationPeriod(candidate.probationPeriod || "");
//         setPackageDailyAllowance(candidate.dailyAllowance || "");
//         setPackagePerformanceAllowance(candidate.performanceAllowance || "");
//         setIsPackageModalOpen(true);
//     };

//     const handleOpenDetailsModal = (candidate) => {
//         setSelectedCandidate(candidate);
//         setIsDetailsModalOpen(true);
//     };

//     const handleSavePackage = async () => {
//         const clientId = getClientId();
//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
//                 applicationId: selectedCandidate._id,
//                 clientId: clientId,
//                 finalSalary: packageSalary,
//                 dateOfJoining: packageJoiningDate,
//                 noticePeriod: packageNoticePeriod,
//                 probationPeriod: packageProbationPeriod,
//                 dailyAllowance: packageDailyAllowance,
//                 performanceAllowance: packagePerformanceAllowance,
//             });
//             if (res.data.success) {
//                 alert("Package updated successfully!");
//                 setIsPackageModalOpen(false);
//                 fetchCandidates();
//             }
//         } catch (err) {
//             console.error("Save package error:", err);
//             alert("Failed to save package");
//         }
//     };

//     const handleOpenDocsModal = async (candidate) => {
//         setSelectedCandidate(candidate);
//         setDocsForm({ agreementsContent: candidate.adminAgreements || "Please read, sign, and re-upload this agreement for next steps." });
//         setIsDocsModalOpen(true);

//         if (candidate.candidateId?._id || candidate.candidateId) {
//             const candidateId = candidate.candidateId?._id || candidate.candidateId;
//             const clientId = getClientId();
//             try {
//                 setPersonalDocsLoading(true);
//                 const res = await axios.get(`${API_BASE_URL}/candidate/admin/${candidateId}?clientId=${clientId}`);
//                 if (res.data.success) {
//                     setPersonalDocs(res.data.data);
//                 }
//             } catch (err) {
//                 console.error("Failed to fetch candidate documents:", err);
//                 setPersonalDocs(null);
//             } finally {
//                 setPersonalDocsLoading(false);
//             }
//         }
//     };

//     const handleOpenHistoryModal = (candidate) => {
//         setSelectedCandidate(candidate);
//         setIsHistoryModalOpen(true);
//     };

//     const handleDeleteHistoryItem = async (historyId) => {
//         if (!window.confirm("Are you sure you want to delete this history item?")) return;

//         const clientId = getClientId();

//         try {
//             setHistoryLoading(true);
//             const res = await axios.post(`${API_BASE_URL}/applications/delete-history-item`, {
//                 applicationId: selectedCandidate._id,
//                 clientId: clientId,
//                 historyId: historyId
//             });

//             if (res.data.success) {
//                 alert("History item deleted successfully!");
//                 setSelectedCandidate(res.data.application);
//                 setCandidates(prev => prev.map(c => c._id === res.data.application._id ? res.data.application : c));
//             }
//         } catch (err) {
//             console.error("Failed to delete history item:", err);
//             alert("Failed to delete history item");
//         } finally {
//             setHistoryLoading(false);
//         }
//     };

//     const handleOpenAssessmentDetails = (candidate) => {
//         if (!candidate.assessmentResults || candidate.assessmentResults.length === 0) {
//             alert("No assessment data available for this candidate.");
//             return;
//         }

//         const allAssessments = candidate.assessmentResults.map((result) => {
//             let matchedQuiz = null;
//             if (result.quizId && typeof result.quizId === 'object' && result.quizId.questions) {
//                 matchedQuiz = result.quizId;
//             } else {
//                 const quizId = typeof result.quizId === 'object' ? result.quizId?._id : result.quizId;
//                 matchedQuiz = quizzes.find(q => String(q._id) === String(quizId));

//                 if (!matchedQuiz && candidate.comment) {
//                     const titleMatch = candidate.comment.match(/"([^"]+)"/);
//                     if (titleMatch?.[1]) {
//                         matchedQuiz = quizzes.find(q => q.title === titleMatch[1]);
//                     }
//                 }
//             }

//             let enrichedAnswers = [];

//             if (matchedQuiz && matchedQuiz.questions && matchedQuiz.questions.length > 0) {
//                 enrichedAnswers = matchedQuiz.questions.map((q, idx) => {
//                     const storedByText = result.answers?.find(a => a.questionText === q.questionText);
//                     const storedByIndex = result.answers?.[idx];
//                     const storedAns = storedByText || storedByIndex;

//                     const selected = storedAns?.selectedOption || "Not Answered";
//                     const correct = q.correctAnswer || "";

//                     return {
//                         questionText: q.questionText,
//                         options: q.options || [],
//                         correctAnswer: correct,
//                         selectedOption: selected,
//                         isCorrect: String(selected).trim() === String(correct).trim(),
//                         marks: q.marks || 1,
//                     };
//                 });
//             } else if (result.answers && result.answers.length > 0) {
//                 enrichedAnswers = result.answers.map(ans => ({
//                     questionText: ans.questionText || "Question",
//                     options: ans.options?.length > 0
//                         ? ans.options
//                         : [ans.selectedOption, ans.correctAnswer].filter(Boolean),
//                     correctAnswer: ans.correctAnswer || "",
//                     selectedOption: ans.selectedOption || "Not Answered",
//                     isCorrect: ans.isCorrect !== undefined
//                         ? ans.isCorrect
//                         : String(ans.selectedOption).trim() === String(ans.correctAnswer).trim(),
//                     marks: ans.marks || 1
//                 }));
//             }

//             return {
//                 ...result,
//                 answers: enrichedAnswers,
//                 quizTitle: matchedQuiz?.title || "Assessment"
//             };
//         });

//         setSelectedAssessmentData(allAssessments);
//         setSelectedCandidate(candidate);
//         setIsAssessmentModalOpen(true);
//     };

//     const [docsFile, setDocsFile] = useState(null);

//     const handleSendAgreements = async () => {
//         const formData = new FormData();
//         const clientId = getClientId();
//         formData.append("applicationId", selectedCandidate._id);
//         formData.append("clientId", clientId);
//         formData.append("agreementsContent", docsForm.agreementsContent);
//         if (docsFile) {
//             formData.append("adminAttachment", docsFile);
//         }

//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/send-agreements`, formData, {
//                 headers: { "Content-Type": "multipart/form-data" }
//             });
//             if (res.data.success) {
//                 alert("Agreements sent successfully!");
//                 setDocsFile(null);
//                 fetchCandidates();
//             }
//         } catch (err) {
//             console.error(err);
//             alert("Failed to send agreements");
//         }
//     };

//     const handleReviewDocs = async (status) => {
//         const clientId = getClientId();
//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/review-documents`, {
//                 applicationId: selectedCandidate._id,
//                 clientId: clientId,
//                 status
//             });
//             if (res.data.success) {
//                 alert(`Documents ${status}`);
//                 setIsDocsModalOpen(false);
//                 fetchCandidates();
//             }
//         } catch (err) {
//             console.error(err);
//             alert("Failed to update status");
//         }
//     };

//     // Helper functions for fuzzy search
//     const normalize = (str) => (str || "").toLowerCase().replace(/\s+/g, "");
//     const levenshtein = (a, b) => {
//         const al = a.length;
//         const bl = b.length;
//         const dp = Array.from({ length: al + 1 }, () => Array(bl + 1).fill(0));
//         for (let i = 0; i <= al; i++) dp[i][0] = i;
//         for (let j = 0; j <= bl; j++) dp[0][j] = j;
//         for (let i = 1; i <= al; i++) {
//             for (let j = 1; j <= bl; j++) {
//                 const cost = a[i - 1] === b[j - 1] ? 0 : 1;
//                 dp[i][j] = Math.min(
//                     dp[i - 1][j] + 1,
//                     dp[i][j - 1] + 1,
//                     dp[i - 1][j - 1] + cost
//                 );
//             }
//         }
//         return dp[al][bl];
//     };

//     const filteredCandidates = candidates.filter(c => {
//         if (c.jobId?.role?.toLowerCase().includes("resign") || c.status === "Resigned" || c.documentType === "Resignation" || c.jobId?.jobType === "short") return false;

//         const normQuery = normalize(searchQuery);
//         const candidateName = `${c.firstName} ${c.lastName}`;
//         const normName = normalize(candidateName);
//         const role = c.jobId?.role || "";
//         const normRole = normalize(role);

//         const nameMatch = normName.includes(normQuery) || levenshtein(normName, normQuery) <= 2;
//         const roleMatch = normRole.includes(normQuery) || levenshtein(normRole, normQuery) <= 2;
//         const matchesSearch = nameMatch || roleMatch;

//         const matchesScore = (c.technicalScore || 0) >= scoreFilter;
//         const matchesRole = roleFilter ? (c.jobId?.role === roleFilter) : true;
//         const matchesDate = dateFilter ? new Date(c.appliedAt).toISOString().slice(0, 10) === dateFilter : true;
//         const matchesStatus = statusFilter ? (c.status === statusFilter) : true;

//         return matchesSearch && matchesScore && matchesRole && matchesDate && matchesStatus;
//     });

//     // Pagination Handlers
//     const handleItemsPerPageChange = (limit) => {
//         setPagination({
//             currentPage: 1,
//             limit: limit,
//             totalCount: filteredCandidates.length,
//             totalPages: Math.ceil(filteredCandidates.length / limit)
//         });
//     };

//     const handlePrevPage = () => {
//         if (pagination.currentPage > 1) {
//             setPagination(prev => ({
//                 ...prev,
//                 currentPage: prev.currentPage - 1
//             }));
//         }
//     };

//     const handleNextPage = () => {
//         if (pagination.currentPage < pagination.totalPages) {
//             setPagination(prev => ({
//                 ...prev,
//                 currentPage: prev.currentPage + 1
//             }));
//         }
//     };

//     const handlePageClick = (page) => {
//         setPagination(prev => ({
//             ...prev,
//             currentPage: page
//         }));
//     };

//     const getPageNumbers = () => {
//         const pageNumbers = [];
//         for (let i = 1; i <= pagination.totalPages; i++) {
//             if (
//                 i === 1 ||
//                 i === pagination.totalPages ||
//                 (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
//             ) {
//                 pageNumbers.push(i);
//             } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
//                 pageNumbers.push("...");
//             }
//         }
//         return pageNumbers;
//     };

//     useEffect(() => {
//         setPagination(prev => ({
//             ...prev,
//             totalCount: filteredCandidates.length,
//             totalPages: Math.ceil(filteredCandidates.length / prev.limit),
//             currentPage: 1
//         }));
//     }, [filteredCandidates.length, searchQuery, scoreFilter, roleFilter, dateFilter, statusFilter]);

//     const indexOfLastItem = pagination.currentPage * pagination.limit;
//     const indexOfFirstItem = indexOfLastItem - pagination.limit;
//     const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);

//     const resetFilters = () => {
//         setSearchQuery("");
//         setScoreFilter(0);
//         setRoleFilter("");
//         setRoleSearchQuery("");
//         setDateFilter("");
//         setStatusFilter("");
//     };

//     if (loading) return (
//         <div style={{ backgroundColor: 'white' }} className="emp-dash">
//             <main className="p-4 sm:p-6 lg:p-8">
//                 <div className="py-10 text-center">
//                     <div className="flex flex-col items-center justify-center gap-3">
//                         <div className="emp-dash__spinner"></div>
//                         <span className="text-sm font-medium text-gray-500">Syncing score data...</span>
//                     </div>
//                 </div>
//             </main>
//         </div>
//     );

//     return (
//         <div style={{ backgroundColor: 'white' }} className="emp-dash">
//             <main className="">
//                 {/* Dashboard Header */}
//                 <div className="emp-dash__header">
//                     <div>
//                         <h1 className="emp-dash__greeting">
//                             Score <span>Board</span>
//                         </h1>
//                         <p className="emp-dash__subtitle">
//                             Evaluate and manage candidate scores
//                         </p>
//                     </div>
//                     <div className="emp-dash__date-pill">
//                         <FiClipboard />
//                         <span>
//                             {new Date().toLocaleDateString("en-US", {
//                                 weekday: "short",
//                                 year: "numeric",
//                                 month: "short",
//                                 day: "numeric",
//                             })}
//                         </span>
//                     </div>
//                 </div>

//                 {/* Top KPI Stats Grid */}
//                 <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4 mb-6">
//                     <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
//                         <div className="emp-dash__stat-top">
//                             <span className="emp-dash__stat-label">Total Candidates</span>
//                             <div className="emp-dash__stat-icon emp-dash__stat-icon--rate">
//                                 <FiUsers />
//                             </div>
//                         </div>
//                         <div className="emp-dash__stat-value">{candidates.length}</div>
//                         <div className="emp-dash__stat-meta">total applications</div>
//                     </div>

//                     <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
//                         <div className="emp-dash__stat-top">
//                             <span className="emp-dash__stat-label">Selected</span>
//                             <div className="emp-dash__stat-icon emp-dash__stat-icon--present">
//                                 <FiCheckCircle />
//                             </div>
//                         </div>
//                         <div className="emp-dash__stat-value">{candidates.filter((c) => c.status === "Selected").length}</div>
//                         <div className="emp-dash__stat-meta">candidates selected</div>
//                     </div>

//                     <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
//                         <div className="emp-dash__stat-top">
//                             <span className="emp-dash__stat-label">Interview Stage</span>
//                             <div className="emp-dash__stat-icon emp-dash__stat-icon--late">
//                                 <FiCalendar />
//                             </div>
//                         </div>
//                         <div className="emp-dash__stat-value">{candidates.filter((c) => c.status === "Interview").length}</div>
//                         <div className="emp-dash__stat-meta">in interview process</div>
//                     </div>

//                     <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
//                         <div className="emp-dash__stat-top">
//                             <span className="emp-dash__stat-label">Filtered Results</span>
//                             <div className="emp-dash__stat-icon emp-dash__stat-icon--rate">
//                                 <FiFilter />
//                             </div>
//                         </div>
//                         <div className="emp-dash__stat-value">{filteredCandidates.length}</div>
//                         <div className="emp-dash__stat-meta">matching filters</div>
//                     </div>

//                     <div className="emp-dash__stat col-span-2 lg:col-span-1 cursor-pointer hover:scale-105 transition-transform duration-200">
//                         <div className="emp-dash__stat-top">
//                             <span className="emp-dash__stat-label">Avg Technical Score</span>
//                             <div className="emp-dash__stat-icon emp-dash__stat-icon--present">
//                                 <FiTrendingUp />
//                             </div>
//                         </div>
//                         <div className="emp-dash__stat-value text-base sm:text-lg md:text-xl font-bold truncate">
//                             {candidates.length > 0
//                                 ? Math.round(candidates.reduce((sum, c) => sum + (c.technicalScore || 0), 0) / candidates.length)
//                                 : 0}%
//                         </div>
//                         <div className="emp-dash__stat-meta">overall average</div>
//                     </div>
//                 </div>

//                 {/* Filters Section */}
//                 <div className="emp-dash__card mb-6">
//                     <div className="hidden lg:block">
//                         <div className="flex items-center justify-between gap-3 p-3 bg-white rounded-xl border border-gray-200">
//                             <div className="flex items-center gap-2 flex-1 min-w-0">
//                                 {/* Search */}
//                                 <div className="relative min-w-[140px] flex-1 max-w-[200px]">
//                                     <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
//                                     <input
//                                         type="text"
//                                         placeholder="Search Name or Role..."
//                                         value={searchQuery}
//                                         onChange={(e) => setSearchQuery(e.target.value)}
//                                         className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
//                                     />
//                                 </div>

//                                 {/* Role Filter */}
//                                 <div className="relative" ref={roleDropdownRef}>
//                                     <button
//                                         onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//                                         className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg border transition-all bg-white whitespace-nowrap ${roleFilter
//                                             ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
//                                             : "border-gray-300 text-gray-700 hover:bg-gray-50"
//                                             }`}
//                                     >
//                                         <FiBriefcase className="text-gray-400 text-[10px]" />
//                                         <span className="truncate max-w-[100px]">{roleFilter || "Roles"}</span>
//                                         <span className="text-gray-400 text-[10px]">▾</span>
//                                     </button>
//                                     {isRoleDropdownOpen && (
//                                         <div
//                                             className="fixed bg-white border border-gray-200 rounded-lg shadow-2xl min-w-[200px] max-h-60 overflow-y-auto"
//                                             style={{
//                                                 zIndex: 99999,
//                                                 top: roleDropdownRef.current ? roleDropdownRef.current.getBoundingClientRect().bottom + 4 : 'auto',
//                                                 left: roleDropdownRef.current ? roleDropdownRef.current.getBoundingClientRect().left : 'auto',
//                                             }}
//                                         >
//                                             <div className="p-2 border-b border-gray-100 bg-gray-50">
//                                                 <div className="relative">
//                                                     <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                                                     <input
//                                                         type="text"
//                                                         className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                                                         placeholder="Search roles..."
//                                                         value={roleSearchQuery}
//                                                         onChange={(e) => setRoleSearchQuery(e.target.value)}
//                                                         onClick={(e) => e.stopPropagation()}
//                                                         autoFocus
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div
//                                                 onClick={() => {
//                                                     setRoleFilter('');
//                                                     setIsRoleDropdownOpen(false);
//                                                     setRoleSearchQuery('');
//                                                 }}
//                                                 className="px-3 py-2 text-xs font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
//                                             >
//                                                 All Roles
//                                             </div>
//                                             {roles
//                                                 .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
//                                                 .map((r) => (
//                                                     <div
//                                                         key={r._id}
//                                                         onClick={() => {
//                                                             setRoleFilter(r.name);
//                                                             setIsRoleDropdownOpen(false);
//                                                             setRoleSearchQuery('');
//                                                         }}
//                                                         className={`px-3 py-2 text-xs cursor-pointer hover:bg-blue-50 ${roleFilter === r.name ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
//                                                             }`}
//                                                     >
//                                                         {r.name}
//                                                     </div>
//                                                 ))}
//                                             {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
//                                                 <div className="px-3 py-2 text-xs text-gray-400 text-center">
//                                                     No roles found
//                                                 </div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Status Filter */}
//                                 <div className="relative" ref={statusDropdownRef}>
//                                     <button
//                                         onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
//                                         className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg border transition-all bg-white whitespace-nowrap ${statusFilter
//                                             ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
//                                             : "border-gray-300 text-gray-700 hover:bg-gray-50"
//                                             }`}
//                                     >
//                                         <FiCheckCircle className="text-gray-400 text-[10px]" />
//                                         <span className="truncate max-w-[100px]">{statusFilter || "Status"}</span>
//                                         <span className="text-gray-400 text-[10px]">▾</span>
//                                     </button>
//                                     {isStatusDropdownOpen && (
//                                         <div
//                                             className="fixed bg-white border border-gray-200 rounded-lg shadow-2xl min-w-[200px] max-h-60 overflow-y-auto"
//                                             style={{
//                                                 zIndex: 99999,
//                                                 top: statusDropdownRef.current ? statusDropdownRef.current.getBoundingClientRect().bottom + 4 : 'auto',
//                                                 left: statusDropdownRef.current ? statusDropdownRef.current.getBoundingClientRect().left : 'auto',
//                                             }}
//                                         >
//                                             <div
//                                                 onClick={() => {
//                                                     setStatusFilter('');
//                                                     setIsStatusDropdownOpen(false);
//                                                 }}
//                                                 className="px-3 py-2 text-xs font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
//                                             >
//                                                 All Statuses
//                                             </div>
//                                             {['Pending', 'Shortlisted', 'Interview', 'Selected', 'Rejected'].map((status) => (
//                                                 <div
//                                                     key={status}
//                                                     onClick={() => {
//                                                         setStatusFilter(status);
//                                                         setIsStatusDropdownOpen(false);
//                                                     }}
//                                                     className={`px-3 py-2 text-xs cursor-pointer hover:bg-blue-50 ${statusFilter === status ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
//                                                         }`}
//                                                 >
//                                                     {status}
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Score Filter */}
//                                 <div className="relative w-[130px]">
//                                     <select
//                                         className="w-full h-8 pl-3 pr-8 py-1.5 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white appearance-none transition-all"
//                                         value={scoreFilter}
//                                         onChange={(e) => setScoreFilter(Number(e.target.value))}
//                                     >
//                                         <option value="0">All Scores</option>
//                                         <option value="60">60% & Above</option>
//                                         <option value="70">70% & Above</option>
//                                         <option value="80">80% & Above</option>
//                                         <option value="90">90% & Above</option>
//                                     </select>
//                                     <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
//                                         <FiStar className="text-xs text-gray-400" />
//                                     </div>
//                                 </div>

//                                 {/* Date Filter */}
//                                 <div className="relative">
//                                     <input
//                                         type="date"
//                                         value={dateFilter}
//                                         onChange={(e) => setDateFilter(e.target.value)}
//                                         onClick={(e) => e.target.showPicker && e.target.showPicker()}
//                                         className="w-[120px] h-8 px-2 py-1 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Right - Action Buttons */}
//                             <div className="flex items-center gap-1.5 flex-shrink-0">
//                                 {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter || statusFilter) && (
//                                     <button
//                                         onClick={resetFilters}
//                                         className="flex items-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all shadow-sm whitespace-nowrap"
//                                     >
//                                         <FiTrash2 className="w-3 h-3" />
//                                         Clear
//                                     </button>
//                                 )}
//                             </div>
//                         </div>
//                     </div>

//                     {/* Mobile View */}
//                     <div className="lg:hidden">
//                         <div className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-200">
//                             <button
//                                 onClick={() => setShowMobileFilters(!showMobileFilters)}
//                                 className="flex items-center gap-2 text-sm font-semibold text-gray-700"
//                             >
//                                 <FiFilter className="text-blue-600 text-base" />
//                                 <span>Filters &amp; Actions</span>
//                                 {showMobileFilters ? (
//                                     <span className="text-gray-400">▲</span>
//                                 ) : (
//                                     <span className="text-gray-400">▼</span>
//                                 )}
//                             </button>
//                             <span className="text-xs text-gray-500">
//                                 <strong>{filteredCandidates.length}</strong> candidates
//                             </span>
//                         </div>

//                         {showMobileFilters && (
//                             <div className="mt-2 p-4 bg-white rounded-xl border border-gray-200 space-y-3">
//                                 <div>
//                                     <label className="block text-xs font-medium text-gray-600 mb-1">Search Name or Role</label>
//                                     <div className="relative">
//                                         <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
//                                         <input
//                                             type="text"
//                                             placeholder="Search Name or Role..."
//                                             value={searchQuery}
//                                             onChange={(e) => setSearchQuery(e.target.value)}
//                                             className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="relative" ref={roleDropdownRef}>
//                                     <label className="block text-xs font-medium text-gray-600 mb-1">Role</label>
//                                     <button
//                                         onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//                                         className={`w-full flex items-center justify-between px-3 py-2.5 text-sm font-medium rounded-lg border transition-all bg-white ${roleFilter
//                                             ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
//                                             : "border-gray-300 text-gray-700"
//                                             }`}
//                                     >
//                                         <span className="flex items-center gap-2">
//                                             <FiBriefcase className="text-gray-400" />
//                                             {roleFilter || "All Roles"}
//                                         </span>
//                                         <span className="text-gray-400">▾</span>
//                                     </button>
//                                     {isRoleDropdownOpen && (
//                                         <div className="absolute left-0 right-0 z-50 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                                             <div className="p-2 border-b border-gray-100 bg-gray-50">
//                                                 <div className="relative">
//                                                     <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                                                     <input
//                                                         type="text"
//                                                         className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                                                         placeholder="Search roles..."
//                                                         value={roleSearchQuery}
//                                                         onChange={(e) => setRoleSearchQuery(e.target.value)}
//                                                         onClick={(e) => e.stopPropagation()}
//                                                         autoFocus
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div
//                                                 onClick={() => {
//                                                     setRoleFilter('');
//                                                     setIsRoleDropdownOpen(false);
//                                                     setRoleSearchQuery('');
//                                                 }}
//                                                 className="px-3 py-2.5 text-sm font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
//                                             >
//                                                 All Roles
//                                             </div>
//                                             {roles
//                                                 .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
//                                                 .map((r) => (
//                                                     <div
//                                                         key={r._id}
//                                                         onClick={() => {
//                                                             setRoleFilter(r.name);
//                                                             setIsRoleDropdownOpen(false);
//                                                             setRoleSearchQuery('');
//                                                         }}
//                                                         className={`px-3 py-2.5 text-sm cursor-pointer hover:bg-blue-50 ${roleFilter === r.name ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
//                                                             }`}
//                                                     >
//                                                         {r.name}
//                                                     </div>
//                                                 ))}
//                                         </div>
//                                     )}
//                                 </div>

//                                 <div className="relative" ref={statusDropdownRef}>
//                                     <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
//                                     <button
//                                         onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
//                                         className={`w-full flex items-center justify-between px-3 py-2.5 text-sm font-medium rounded-lg border transition-all bg-white ${statusFilter
//                                             ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
//                                             : "border-gray-300 text-gray-700"
//                                             }`}
//                                     >
//                                         <span className="flex items-center gap-2">
//                                             <FiCheckCircle className="text-gray-400" />
//                                             {statusFilter || "All Statuses"}
//                                         </span>
//                                         <span className="text-gray-400">▾</span>
//                                     </button>
//                                     {isStatusDropdownOpen && (
//                                         <div className="absolute left-0 right-0 z-50 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                                             <div
//                                                 onClick={() => {
//                                                     setStatusFilter('');
//                                                     setIsStatusDropdownOpen(false);
//                                                 }}
//                                                 className="px-3 py-2.5 text-sm font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
//                                             >
//                                                 All Statuses
//                                             </div>
//                                             {['Pending', 'Shortlisted', 'Interview', 'Selected', 'Rejected'].map((status) => (
//                                                 <div
//                                                     key={status}
//                                                     onClick={() => {
//                                                         setStatusFilter(status);
//                                                         setIsStatusDropdownOpen(false);
//                                                     }}
//                                                     className={`px-3 py-2.5 text-sm cursor-pointer hover:bg-blue-50 ${statusFilter === status ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
//                                                         }`}
//                                                 >
//                                                     {status}
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>

//                                 <div className="grid grid-cols-2 gap-2">
//                                     <div>
//                                         <label className="block text-xs font-medium text-gray-600 mb-1">Min Score</label>
//                                         <select
//                                             className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
//                                             value={scoreFilter}
//                                             onChange={(e) => setScoreFilter(Number(e.target.value))}
//                                         >
//                                             <option value="0">All Scores</option>
//                                             <option value="60">60%+</option>
//                                             <option value="70">70%+</option>
//                                             <option value="80">80%+</option>
//                                             <option value="90">90%+</option>
//                                         </select>
//                                     </div>
//                                     <div>
//                                         <label className="block text-xs font-medium text-gray-600 mb-1">Date</label>
//                                         <input
//                                             type="date"
//                                             value={dateFilter}
//                                             onChange={(e) => setDateFilter(e.target.value)}
//                                             onClick={(e) => e.target.showPicker && e.target.showPicker()}
//                                             className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="pt-3 border-t border-gray-200">
//                                     {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter || statusFilter) && (
//                                         <button
//                                             onClick={resetFilters}
//                                             className="w-full flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all"
//                                         >
//                                             <FiTrash2 className="w-4 h-4" />
//                                             Clear Filters
//                                         </button>
//                                     )}
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {error && <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3">
//                     <FiX className="text-red-500 text-lg" />
//                     <span className="text-sm font-medium text-red-700">{error}</span>
//                 </div>}

//                 <div className="emp-dash__card mb-6">
//                     {/* Table and Card Views */}
//                     {filteredCandidates.length > 0 ? (
//                         <>
//                             {/* Desktop Table View */}
//                             <div className="emp-dash__table-wrap overflow-x-auto w-full hidden md:block">
//                                 <table className="emp-dash__table min-w-[800px] w-full">
//                                     <thead>
//                                         <tr>
//                                             <th className="py-2 text-center">Candidate</th>
//                                             <th className="py-2 text-center">Role</th>
//                                             <th className="py-2 text-center">Appearance (10)</th>
//                                             <th className="py-2 text-center">Knowledge (10)</th>
//                                             <th className="py-2 text-center">Avg Score (100)</th>
//                                             <th className="py-2 text-center">Rating (10)</th>
//                                             <th className="py-2 text-center">TAT (Days)</th>
//                                             <th className="py-2 text-center">Status</th>
//                                             <th className="py-2 text-center">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {currentItems.map((c) => {
//                                             const hasAssessment = c.assessmentResults && c.assessmentResults.length > 0;
//                                             const avgScore = hasAssessment
//                                                 ? Math.round(c.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / c.assessmentResults.length)
//                                                 : c.technicalScore || 0;

//                                             return (
//                                                 <tr key={c._id} className="border-b hover:bg-gray-50 transition-colors">
//                                                     <td className="px-2 py-2 font-medium text-center">
//                                                         <div className="flex flex-col items-center">
//                                                             <span className="text-gray-900 whitespace-nowrap font-bold text-sm">{c.firstName} {c.lastName}</span>
//                                                             <span className="text-[10px] text-gray-500">{new Date(c.appliedAt).toLocaleDateString()}</span>
//                                                         </div>
//                                                     </td>
//                                                     <td className="px-2 py-2 text-center">
//                                                         <span className="bg-gray-100 text-gray-600 text-[10px] px-2 py-0.5 rounded uppercase font-bold">
//                                                             {c.jobId?.role || "N/A"}
//                                                         </span>
//                                                     </td>
//                                                     <td className="px-2 py-2 text-center">
//                                                         <input
//                                                             type="number"
//                                                             min="0"
//                                                             max="10"
//                                                             className="w-16 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                             value={c.appearanceScore || 0}
//                                                             onChange={(e) => handleUpdateScore(c._id, "appearanceScore", e.target.value)}
//                                                         />
//                                                     </td>
//                                                     <td className="px-2 py-2 text-center">
//                                                         <input
//                                                             type="number"
//                                                             min="0"
//                                                             max="10"
//                                                             className="w-16 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                             value={c.workKnowledge || 0}
//                                                             onChange={(e) => handleUpdateScore(c._id, "workKnowledge", e.target.value)}
//                                                         />
//                                                     </td>
//                                                     <td className="px-2 py-2 text-center">
//                                                         <div className="flex items-center justify-center gap-2">
//                                                             <div className="flex items-center gap-1">
//                                                                 <span className="text-[10px] text-gray-500 font-bold">AVG</span>
//                                                                 {hasAssessment ? (
//                                                                     <span className="w-16 p-1 border rounded text-xs text-center font-bold bg-gray-100 text-gray-800">
//                                                                         {avgScore}
//                                                                     </span>
//                                                                 ) : (
//                                                                     <input
//                                                                         type="number"
//                                                                         min="0"
//                                                                         max="100"
//                                                                         data-gramm="false"
//                                                                         spellCheck="false"
//                                                                         className="w-16 p-1 border rounded text-xs text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white hover:bg-gray-50 transition-colors"
//                                                                         value={c.technicalScore || 0}
//                                                                         onChange={(e) => handleUpdateScore(c._id, "technicalScore", e.target.value)}
//                                                                     />
//                                                                 )}
//                                                             </div>
//                                                             <button
//                                                                 onClick={() => handleOpenAssessmentDetails(c)}
//                                                                 disabled={!hasAssessment}
//                                                                 className={`p-2 rounded-xl transition-all duration-300 shadow-sm border flex items-center justify-center transform hover:-translate-y-0.5 ${hasAssessment
//                                                                         ? 'bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white border-indigo-100 hover:shadow-md cursor-pointer'
//                                                                         : 'bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed opacity-50'
//                                                                     }`}
//                                                                 title={hasAssessment ? "View Answer Sheets" : "No assessment available"}
//                                                             >
//                                                                 <FiEye size={14} className={`transition-transform ${hasAssessment ? 'group-hover:scale-110' : ''}`} />
//                                                             </button>
//                                                         </div>
//                                                     </td>

//                                                     <td className="px-2 py-2 text-center">
//                                                         <select
//                                                             className="p-1 border rounded text-xs font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                             value={c.overallRating || 0}
//                                                             onChange={(e) => handleUpdateScore(c._id, "overallRating", e.target.value)}
//                                                         >
//                                                             {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(v => <option key={v} value={v}>{v}</option>)}
//                                                         </select>
//                                                     </td>
//                                                     <td className="px-2 py-2 text-center">
//                                                         {c.appliedAt && c.offerSentAt ? (
//                                                             <span className="bg-indigo-50 text-indigo-700 px-2 py-1 rounded-lg text-xs font-bold border border-indigo-100 shadow-sm">
//                                                                 {Math.ceil(Math.abs(new Date(c.offerSentAt) - new Date(c.appliedAt)) / (1000 * 60 * 60 * 24))} Days
//                                                             </span>
//                                                         ) : (
//                                                             <span className="text-gray-400 text-[10px] font-black italic uppercase tracking-widest">
//                                                                 {c.status === "Selected" && !c.offerSentAt ? "Pending Offer" : "---"}
//                                                             </span>
//                                                         )}
//                                                     </td>
//                                                     <td className="px-2 py-2 text-center">
//                                                         <select
//                                                             className={`p-1 border rounded text-[10px] font-bold ${c.status === "Selected" ? "text-green-600 bg-green-50" :
//                                                                 c.status === "Interview" ? "text-blue-600 bg-blue-50" : "text-gray-600"
//                                                                 }`
//                                                             }

//                                                             value={c.status || "Pending"}
//                                                             onChange={(e) => handleUpdateScore(c._id, "status", e.target.value)}
//                                                         >
//                                                             <option value="Pending">PENDING</option>
//                                                             <option value="Shortlisted">SHORTLISTED</option>
//                                                             <option value="Interview">INTERVIEW</option>
//                                                             <option value="Selected">SELECTED</option>
//                                                             <option value="Rejected">REJECTED</option>
//                                                         </select>
//                                                         {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled') && c.candidateInterviewStatus && (
//                                                             <div className="mt-1">
//                                                                 <span className={`text-[8px] font-black uppercase tracking-tighter ${c.candidateInterviewStatus === 'Confirmed' ? 'text-indigo-600 bg-indigo-50 px-1 rounded' : c.candidateInterviewStatus === 'Declined' ? 'text-rose-600 bg-rose-50 px-1 rounded' : 'text-amber-600 bg-amber-50 px-1 rounded'}`}>
//                                                                     {c.candidateInterviewStatus === 'Pending' ? 'Awaiting Conf' : `Interview ${c.candidateInterviewStatus}`}
//                                                                 </span>
//                                                                 {c.candidateInterviewNote && (
//                                                                     <div className="text-[8px] text-gray-400 italic truncate max-w-[80px] mx-auto mt-0.5" title={c.candidateInterviewNote}>
//                                                                         "{c.candidateInterviewNote}"
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         )}
//                                                     </td>
//                                                     <td className="px-2 py-2 text-center">
//                                                         <div className="flex justify-center gap-2">
//                                                             {c.status === "Interview" && (
//                                                                 <button
//                                                                     onClick={() => handleOpenInviteModal(c)}
//                                                                     className="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                                                                 >
//                                                                     schedule
//                                                                 </button>
//                                                             )}

//                                                             {c.status === "Selected" && (
//                                                                 <div className="flex gap-2">
//                                                                     <button
//                                                                         onClick={() => handleOpenDetailsModal(c)}
//                                                                         className="px-3 py-1.5 bg-gradient-to-r from-gray-500 to-gray-700 text-white rounded-xl hover:from-gray-600 hover:to-gray-800 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                                                                     >
//                                                                         <FiEye size={12} /> VIEW
//                                                                     </button>
//                                                                     {c.resume && (
//                                                                         <button
//                                                                             onClick={() => {
//                                                                                 const link = document.createElement('a');
//                                                                                 link.href = formatDocUrl(c.resume);
//                                                                                 link.download = `${c.firstName}_Resume.pdf`;
//                                                                                 document.body.appendChild(link);
//                                                                                 link.click();
//                                                                                 document.body.removeChild(link);
//                                                                             }}
//                                                                             className="px-3 py-1.5 bg-gradient-to-r from-blue-400 to-indigo-500 text-white rounded-xl hover:from-blue-500 hover:to-indigo-600 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                                                                             title="Download Resume"
//                                                                         >
//                                                                             <FiDownload size={12} /> RESUME
//                                                                         </button>
//                                                                     )}
//                                                                     <button
//                                                                         onClick={() => handleOpenOfferModal(c)}
//                                                                         className="px-3 py-1.5 bg-gradient-to-r from-purple-500 to-fuchsia-600 text-white rounded-xl hover:from-purple-600 hover:to-fuchsia-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                                                                     >
//                                                                         OFFER
//                                                                     </button>

//                                                                     <button
//                                                                         onClick={() => handleOpenDocsModal(c)}
//                                                                         className={`px-3 py-1.5 text-white rounded-xl transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5 ${c.docReviewStatus === "Accepted"
//                                                                             ? "bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600"
//                                                                             : c.docReviewStatus === "Pending"
//                                                                                 ? "bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600"
//                                                                                 : "bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900"
//                                                                             }`
//                                                                         }

//                                                                     >
//                                                                         DOCS
//                                                                     </button>

//                                                                     <button
//                                                                         onClick={() => handleOpenPackageModal(c)}
//                                                                         className="px-3 py-1.5 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-xl hover:from-indigo-600 hover:to-blue-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                                                                     >
//                                                                         PACKAGE
//                                                                     </button>

//                                                                     <button
//                                                                         onClick={() => handleOpenHistoryModal(c)}
//                                                                         className="px-3 py-1.5 bg-gradient-to-r from-slate-500 to-slate-700 text-white rounded-xl hover:from-slate-600 hover:to-slate-800 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                                                                         title="Document History"
//                                                                     >
//                                                                         <FiClock size={12} /> HISTORY
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             )
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>

//                             {/* Mobile Card View */}
//                             <div className="md:hidden space-y-4 p-2">
//                                 {currentItems.map((c) => {
//                                     const hasAssessment = c.assessmentResults && c.assessmentResults.length > 0;
//                                     const avgScore = hasAssessment
//                                         ? Math.round(c.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / c.assessmentResults.length)
//                                         : c.technicalScore || 0;

//                                     return (
//                                         <div key={c._id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-200">
//                                             {/* Card Header */}
//                                             <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100">
//                                                 <div className="flex justify-between items-start">
//                                                     <div className="flex-1 min-w-0">
//                                                         <h3 className="font-bold text-gray-900 text-sm truncate">
//                                                             {c.firstName} {c.lastName}
//                                                         </h3>
//                                                         <div className="flex items-center gap-2 mt-0.5">
//                                                             <span className="text-[10px] text-gray-500">
//                                                                 {new Date(c.appliedAt).toLocaleDateString()}
//                                                             </span>
//                                                             <span className="bg-gray-100 text-gray-600 text-[9px] px-1.5 py-0.5 rounded uppercase font-bold truncate max-w-[120px]">
//                                                                 {c.jobId?.role || "N/A"}
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="flex items-center gap-1 ml-2">
//                                                         <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase ${c.status === "Selected" ? "bg-green-100 text-green-700" :
//                                                                 c.status === "Interview" ? "bg-blue-100 text-blue-700" :
//                                                                     c.status === "Shortlisted" ? "bg-yellow-100 text-yellow-700" :
//                                                                         "bg-gray-100 text-gray-600"
//                                                             }`}>
//                                                             {c.status || "Pending"}
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {/* Card Body */}
//                                             <div className="p-4 space-y-3">
//                                                 {/* Scores Grid */}
//                                                 <div className="grid grid-cols-2 gap-2">
//                                                     <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
//                                                         <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Appearance</p>
//                                                         <input
//                                                             type="number"
//                                                             min="0"
//                                                             max="10"
//                                                             className="w-full mt-1 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                             value={c.appearanceScore || 0}
//                                                             onChange={(e) => handleUpdateScore(c._id, "appearanceScore", e.target.value)}
//                                                         />
//                                                     </div>
//                                                     <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
//                                                         <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Knowledge</p>
//                                                         <input
//                                                             type="number"
//                                                             min="0"
//                                                             max="10"
//                                                             className="w-full mt-1 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                             value={c.workKnowledge || 0}
//                                                             onChange={(e) => handleUpdateScore(c._id, "workKnowledge", e.target.value)}
//                                                         />
//                                                     </div>
//                                                     <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
//                                                         <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Avg Score</p>
//                                                         {hasAssessment ? (
//                                                             <span className="w-full mt-1 p-1 border rounded text-xs text-center font-bold bg-gray-100 text-gray-800 block">
//                                                                 {avgScore}
//                                                             </span>
//                                                         ) : (
//                                                             <input
//                                                                 type="number"
//                                                                 min="0"
//                                                                 max="100"
//                                                                 className="w-full mt-1 p-1 border rounded text-xs text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                 value={c.technicalScore || 0}
//                                                                 onChange={(e) => handleUpdateScore(c._id, "technicalScore", e.target.value)}
//                                                             />
//                                                         )}
//                                                     </div>
//                                                     <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
//                                                         <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Rating</p>
//                                                         <select
//                                                             className="w-full mt-1 p-1 border rounded text-xs font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
//                                                             value={c.overallRating || 0}
//                                                             onChange={(e) => handleUpdateScore(c._id, "overallRating", e.target.value)}
//                                                         >
//                                                             {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(v => <option key={v} value={v}>{v}</option>)}
//                                                         </select>
//                                                     </div>
//                                                 </div>

//                                                 {/* TAT Info */}
//                                                 {c.appliedAt && c.offerSentAt && (
//                                                     <div className="text-center bg-indigo-50 rounded-lg p-1.5 border border-indigo-100">
//                                                         <span className="text-[10px] font-bold text-indigo-700">
//                                                             TAT: {Math.ceil(Math.abs(new Date(c.offerSentAt) - new Date(c.appliedAt)) / (1000 * 60 * 60 * 24))} Days
//                                                         </span>
//                                                     </div>
//                                                 )}

//                                                 {/* Status Select and Actions */}
//                                                 <div className="flex flex-wrap items-center gap-2 pt-2 border-t border-gray-100">
//                                                     <div className="flex-1 min-w-[120px]">
//                                                         <select
//                                                             className={`w-full p-1.5 border rounded-lg text-[10px] font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 ${c.status === "Selected" ? "text-green-600 bg-green-50 border-green-200" :
//                                                                     c.status === "Interview" ? "text-blue-600 bg-blue-50 border-blue-200" :
//                                                                         "text-gray-600 bg-gray-50 border-gray-200"
//                                                                 }`}
//                                                             value={c.status || "Pending"}
//                                                             onChange={(e) => handleUpdateScore(c._id, "status", e.target.value)}
//                                                         >
//                                                             <option value="Pending">PENDING</option>
//                                                             <option value="Shortlisted">SHORTLISTED</option>
//                                                             <option value="Interview">INTERVIEW</option>
//                                                             <option value="Selected">SELECTED</option>
//                                                             <option value="Rejected">REJECTED</option>
//                                                         </select>
//                                                     </div>

//                                                     <div className="flex flex-wrap gap-1.5">
//                                                         <button
//                                                             onClick={() => handleOpenAssessmentDetails(c)}
//                                                             disabled={!hasAssessment}
//                                                             className={`p-2 rounded-lg border ${hasAssessment
//                                                                     ? 'bg-indigo-50 text-indigo-600 border-indigo-200 hover:bg-indigo-600 hover:text-white hover:border-indigo-600'
//                                                                     : 'bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed opacity-50'
//                                                                 } transition-all duration-200`}
//                                                             title={hasAssessment ? "View Answer Sheets" : "No assessment available"}
//                                                         >
//                                                             <FiEye size={14} />
//                                                         </button>

//                                                         {c.status === "Interview" && (
//                                                             <button
//                                                                 onClick={() => handleOpenInviteModal(c)}
//                                                                 className="px-3 py-2 bg-blue-600 text-white rounded-lg text-[10px] font-bold hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow"
//                                                             >
//                                                                 INVITE
//                                                             </button>
//                                                         )}

//                                                         {c.status === "Selected" && (
//                                                             <>
//                                                                 <button
//                                                                     onClick={() => handleOpenDetailsModal(c)}
//                                                                     className="p-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-200"
//                                                                     title="View Details"
//                                                                 >
//                                                                     <FiEye size={14} />
//                                                                 </button>
//                                                                 {c.resume && (
//                                                                     <button
//                                                                         onClick={() => {
//                                                                             const link = document.createElement('a');
//                                                                             link.href = formatDocUrl(c.resume);
//                                                                             link.download = `${c.firstName}_Resume.pdf`;
//                                                                             document.body.appendChild(link);
//                                                                             link.click();
//                                                                             document.body.removeChild(link);
//                                                                         }}
//                                                                         className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200"
//                                                                         title="Download Resume"
//                                                                     >
//                                                                         <FiDownload size={14} />
//                                                                     </button>
//                                                                 )}
//                                                                 <button
//                                                                     onClick={() => handleOpenOfferModal(c)}
//                                                                     className="p-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all duration-200"
//                                                                     title="Send Offer"
//                                                                 >
//                                                                     <FiFileText size={14} />
//                                                                 </button>
//                                                                 <button
//                                                                     onClick={() => handleOpenDocsModal(c)}
//                                                                     className={`p-2 text-white rounded-lg transition-all duration-200 ${c.docReviewStatus === "Accepted"
//                                                                             ? "bg-emerald-500 hover:bg-emerald-600"
//                                                                             : c.docReviewStatus === "Pending"
//                                                                                 ? "bg-amber-500 hover:bg-amber-600"
//                                                                                 : "bg-slate-700 hover:bg-slate-800"
//                                                                         }`}
//                                                                     title="Documents"
//                                                                 >
//                                                                     <FiFileText size={14} />
//                                                                 </button>
//                                                                 <button
//                                                                     onClick={() => handleOpenPackageModal(c)}
//                                                                     className="p-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all duration-200"
//                                                                     title="Package Details"
//                                                                 >
//                                                                     <FiBriefcase size={14} />
//                                                                 </button>
//                                                                 <button
//                                                                     onClick={() => handleOpenHistoryModal(c)}
//                                                                     className="p-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-all duration-200"
//                                                                     title="Document History"
//                                                                 >
//                                                                     <FiClock size={14} />
//                                                                 </button>
//                                                             </>
//                                                         )}
//                                                     </div>
//                                                 </div>

//                                                 {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled') && c.candidateInterviewStatus && (
//                                                     <div className="mt-1 text-center">
//                                                         <span className={`text-[8px] font-bold uppercase px-2 py-0.5 rounded ${c.candidateInterviewStatus === 'Confirmed' ? 'bg-indigo-100 text-indigo-700' :
//                                                                 c.candidateInterviewStatus === 'Declined' ? 'bg-rose-100 text-rose-700' :
//                                                                     'bg-amber-100 text-amber-700'
//                                                             }`}>
//                                                             {c.candidateInterviewStatus === 'Pending' ? 'Awaiting Confirmation' : `Interview ${c.candidateInterviewStatus}`}
//                                                         </span>
//                                                         {c.candidateInterviewNote && (
//                                                             <div className="text-[8px] text-gray-400 italic mt-0.5 truncate" title={c.candidateInterviewNote}>
//                                                                 "{c.candidateInterviewNote}"
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>

//                             {/* Pagination */}
//                             {filteredCandidates.length > 0 && (
//                                 <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 border-t border-gray-200/50 bg-gray-50/30">
//                                     <div className="flex flex-wrap items-center gap-3">
//                                         <div className="flex items-center gap-2 text-xs text-gray-500">
//                                             <span>Show</span>
//                                             <select
//                                                 value={pagination.limit}
//                                                 onChange={(e) => {
//                                                     const newLimit = Number(e.target.value);
//                                                     handleItemsPerPageChange(newLimit);
//                                                 }}
//                                                 className="p-1 border border-gray-300 rounded-md bg-white text-gray-700 focus:outline-none"
//                                             >
//                                                 <option value={5}>5</option>
//                                                 <option value={10}>10</option>
//                                                 <option value={20}>20</option>
//                                                 <option value={50}>50</option>
//                                             </select>
//                                             <span>entries</span>
//                                         </div>
//                                         <div className="text-xs text-gray-500 font-medium">
//                                             Showing <strong className="text-gray-800">{indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredCandidates.length)}</strong> of{" "}
//                                             <strong className="text-gray-800">{filteredCandidates.length}</strong> candidates
//                                         </div>
//                                     </div>

//                                     <div className="flex items-center gap-1.5">
//                                         <button
//                                             onClick={handlePrevPage}
//                                             disabled={pagination.currentPage === 1}
//                                             className={`px-2.5 py-1 text-xs font-semibold border rounded-lg transition-all ${pagination.currentPage === 1
//                                                     ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
//                                                     : "text-gray-700 bg-white hover:bg-gray-55 border-gray-300 shadow-sm"
//                                                 }`}
//                                         >
//                                             Prev
//                                         </button>

//                                         {getPageNumbers().map((page, index) => (
//                                             <button
//                                                 key={index}
//                                                 onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
//                                                 disabled={page === "..."}
//                                                 className={`px-3 py-1 text-xs font-semibold border rounded-lg transition-all min-w-[32px] ${page === "..."
//                                                         ? "text-gray-400 bg-transparent border-transparent cursor-default"
//                                                         : pagination.currentPage === page
//                                                             ? "text-white bg-blue-600 border-blue-600 shadow-sm"
//                                                             : "text-gray-700 bg-white hover:bg-gray-55 border-gray-300"
//                                                     }`}
//                                             >
//                                                 {page}
//                                             </button>
//                                         ))}

//                                         <button
//                                             onClick={handleNextPage}
//                                             disabled={pagination.currentPage === pagination.totalPages}
//                                             className={`px-2.5 py-1 text-xs font-semibold border rounded-lg transition-all ${pagination.currentPage === pagination.totalPages
//                                                     ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
//                                                     : "text-gray-700 bg-white hover:bg-gray-55 border-gray-300 shadow-sm"
//                                                 }`}
//                                         >
//                                             Next
//                                         </button>
//                                     </div>
//                                 </div>
//                             )}
//                         </>
//                     ) : (
//                         <div className="emp-dash__card-body py-12 text-center text-gray-500">
//                             <div className="mb-3 text-4xl text-gray-300">👥</div>
//                             <p className="mb-1 text-sm font-semibold text-gray-800">No candidates found</p>
//                             <p className="text-xs text-gray-500 mb-5 max-w-xs mx-auto">There are no candidates matching the selected search query or filters.</p>
//                             {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter || statusFilter) && (
//                                 <button
//                                     onClick={resetFilters}
//                                     className="px-4 py-2 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-55 transition-all shadow-sm"
//                                 >
//                                     Clear Filters
//                                 </button>
//                             )}
//                         </div>
//                     )}
//                 </div>

//                 {/* ========================================= */}
//                 {/* 🔥🔥🔥 INVITE MODAL - UPDATED WITH ADDRESS */}
//                 {/* ========================================= */}
//                 {isInviteModalOpen && (
//                     <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
//                         <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
//                             <button
//                                 onClick={() => setIsInviteModalOpen(false)}
//                                 className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
//                             >
//                                 <FiX className="text-lg" />
//                             </button>
//                             <div className="px-8 pt-8 pb-4">
//                                 <h2 className="text-xl text-gray-800">Send Interview Invite</h2>
//                                 <p className="text-[10px] font-bold uppercase tracking-widest mt-1">Schedule interview for candidate</p>
//                             </div>
//                             <div className="p-8 pt-4">
//                                 <p className="text-sm text-gray-600 mb-4">
//                                     Candidate: <span className="font-semibold text-gray-800">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
//                                 </p>
//                                 <div className="space-y-4">
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
//                                         <input
//                                             type="text"
//                                             className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                                             value={inviteForm.subject}
//                                             onChange={(e) => setInviteForm({ ...inviteForm, subject: e.target.value })}
//                                         />
//                                     </div>
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">Interview Time & Date</label>
//                                         <input
//                                             type="datetime-local"
//                                             className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                                             value={inviteForm.time}
//                                             onChange={(e) => setInviteForm({ ...inviteForm, time: e.target.value })}
//                                             min={new Date().toISOString().slice(0, 16)}
//                                         />
//                                     </div>
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">Interview Mode</label>
//                                         <select
//                                             className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 font-bold text-sm"
//                                             value={inviteForm.interviewMode}
//                                             onChange={(e) => {
//                                                 const selectedValue = e.target.value;
//                                                 const selectedLocation = locations.find(loc => loc.fullAddress === selectedValue);
                                                
//                                                 if (selectedLocation) {
//                                                     // If location selected, set mode as "In-Person" and address as location address
//                                                     setInviteForm({
//                                                         ...inviteForm,
//                                                         interviewMode: "In-Person",
//                                                         interviewAddress: selectedLocation.fullAddress
//                                                     });
//                                                 } else {
//                                                     // If Online/Virtual selected, clear address
//                                                     setInviteForm({
//                                                         ...inviteForm,
//                                                         interviewMode: selectedValue,
//                                                         interviewAddress: ""
//                                                     });
//                                                 }
//                                             }}
//                                         >
//                                             <option value="Online">🌐 Online (Google Meet / Zoom)</option>
//                                             <option value="Virtual">💻 Virtual</option>
//                                             <option value="In-Person">🏢 In-Person (Office)</option>
//                                             {locations.map(loc => (
//                                                 <option key={loc._id} value={loc.fullAddress}>
//                                                     📍 {loc.name} - {loc.fullAddress}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     {/* ✅ Show selected address if In-Person */}
//                                     {inviteForm.interviewMode === "In-Person" && inviteForm.interviewAddress && (
//                                         <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
//                                             <p className="text-[10px] font-bold text-blue-700 uppercase tracking-widest flex items-center gap-2">
//                                                 <FiMapPin size={12} /> Selected Address:
//                                             </p>
//                                             <p className="text-xs font-semibold text-gray-700 mt-1">{inviteForm.interviewAddress}</p>
//                                         </div>
//                                     )}
//                                 </div>
//                                 <div className="flex justify-end gap-3 mt-6">
//                                     <button
//                                         className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
//                                         onClick={() => setIsInviteModalOpen(false)}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <button
//                                         className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 shadow-lg"
//                                         onClick={handleSendInvite}
//                                     >
//                                         Send Invitation
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* ========================================= */}
//                 {/* Document Management Modal - Same as before */}
//                 {/* ========================================= */}
//                 {isDocsModalOpen && (
//                     <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
//                         <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
//                             <button
//                                 onClick={() => setIsDocsModalOpen(false)}
//                                 className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
//                             >
//                                 <FiX className="text-lg" />
//                             </button>
//                             <div className="px-8 pt-8 pb-4">
//                                 <h2 className="text-xl text-gray-800">Document Management</h2>
//                                 <p className="text-[10px] font-bold uppercase tracking-widest mt-1">Review Status: {selectedCandidate?.docReviewStatus}</p>
//                             </div>
//                             <div className="p-8 pt-4 space-y-6 max-h-[70vh] overflow-y-auto">
//                                 {/* Step 1: Send Agreements */}
//                                 <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
//                                     <h3 className="text-sm font-black uppercase text-gray-700 mb-3 tracking-wider">Step 1: Agreements for Candidate</h3>
//                                     <textarea
//                                         className="w-full p-3 border rounded-md text-sm min-h-[150px] focus:ring-2 focus:ring-indigo-500"
//                                         placeholder="Enter agreement terms or instructions..."
//                                         value={docsForm.agreementsContent}
//                                         onChange={(e) => setDocsForm({ ...docsForm, agreementsContent: e.target.value })}
//                                     />
//                                     <div className="mt-3">
//                                         <label className="block text-xs font-bold text-gray-500 mb-1 uppercase">Attach Agreement Check (PDF/Doc)</label>
//                                         <input
//                                             type="file"
//                                             className="w-full text-xs text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
//                                             onChange={(e) => setDocsFile(e.target.files[0])}
//                                         />
//                                     </div>
//                                     <button
//                                         onClick={handleSendAgreements}
//                                         className="mt-3 px-6 py-2 bg-indigo-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-indigo-700"
//                                     >
//                                         Send / Update Agreements
//                                     </button>
//                                 </div>

//                                 {/* Step 2: Review Candidate Upload */}
//                                 {selectedCandidate?.candidateAgreementsUpload && (
//                                     <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
//                                         <h3 className="text-sm font-black uppercase text-blue-800 mb-3 tracking-wider">Step 2: Review Uploaded Document</h3>
//                                         <div className="flex items-center justify-between bg-white p-3 rounded border border-blue-100 mb-4">
//                                             <div className="flex items-center gap-2">
//                                                 <span className="text-xs font-bold text-gray-700">Signed_Agreement.pdf</span>
//                                             </div>
//                                         </div>
//                                         <div className="flex gap-2">
//                                             <button
//                                                 onClick={() => window.open(formatDocUrl(selectedCandidate.candidateAgreementsUpload), "_blank")}
//                                                 className="flex-1 px-6 py-2 bg-indigo-600 text-white rounded-lg text-xs font-black uppercase tracking-widest shadow-lg hover:bg-indigo-700 transition-all active:scale-95 flex items-center justify-center gap-2"
//                                             >
//                                                 <FiEye size={14} /> View
//                                             </button>
//                                             <button
//                                                 onClick={() => {
//                                                     const link = document.createElement('a');
//                                                     link.href = formatDocUrl(selectedCandidate.candidateAgreementsUpload);
//                                                     link.download = `Signed_Agreement_${selectedCandidate.firstName}.pdf`;
//                                                     document.body.appendChild(link);
//                                                     link.click();
//                                                     document.body.removeChild(link);
//                                                 }}
//                                                 className="flex-1 px-6 py-2 bg-emerald-600 text-white rounded-lg text-xs font-black uppercase tracking-widest shadow-lg hover:bg-emerald-700 transition-all active:scale-95 flex items-center justify-center gap-2"
//                                             >
//                                                 <FiDownload size={14} /> Download
//                                             </button>
//                                         </div>
//                                         <div className="flex gap-2 mt-4">
//                                             <button
//                                                 onClick={() => handleReviewDocs("Accepted")}
//                                                 className="flex-1 py-2 bg-green-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-green-700 shadow-md"
//                                             >
//                                                 Accept Documents
//                                             </button>
//                                             <button
//                                                 onClick={() => handleReviewDocs("Rejected")}
//                                                 className="flex-1 py-2 bg-red-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-red-700 shadow-md"
//                                             >
//                                                 Reject & Resubmit
//                                             </button>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {!selectedCandidate?.candidateAgreementsUpload && (
//                                     <div className="text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
//                                         <p className="text-xs font-bold text-gray-400 uppercase">Awaiting candidate upload...</p>
//                                     </div>
//                                 )}

//                                 {/* Step 3: Personal Documents */}
//                                 <div className="bg-white p-4 rounded-lg border border-gray-200">
//                                     <h3 className="text-sm font-black uppercase text-gray-700 mb-4 tracking-wider flex items-center gap-2">
//                                         <FiFileText className="text-blue-500" /> Step 3: Personal Documents & Details
//                                     </h3>

//                                     {personalDocsLoading ? (
//                                         <div className="flex items-center justify-center p-8">
//                                             <div className="w-6 h-6 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
//                                             <p className="ml-3 text-xs font-bold text-gray-400 uppercase tracking-widest">Fetching Docs...</p>
//                                         </div>
//                                     ) : personalDocs ? (
//                                         <div className="space-y-6">
//                                             {/* Document Grid */}
//                                             <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                                                 {[
//                                                     { title: "Aadhar Card", type: "aadharCard" },
//                                                     { title: "PAN Card", type: "panCard" },
//                                                     { title: "10th Certificate", type: "tenthCertificate" },
//                                                     { title: "12th Certificate", type: "twelfthCertificate" },
//                                                     { title: "Graduation", type: "graduationCertificate" },
//                                                     { title: "Passport Photo", type: "passportPhoto" },
//                                                     { title: "Exp. Letters", type: "experienceLetters" }
//                                                 ].map((cat) => {
//                                                     const doc = personalDocs.documents?.[cat.type];
//                                                     const isUploaded = !!doc?.url;
//                                                     return (
//                                                         <div key={cat.type} className={`p-3 rounded-xl border flex items-center justify-between transition-all ${isUploaded ? "bg-emerald-50/30 border-emerald-100" : "bg-gray-50 border-gray-100"}`}>
//                                                             <div className="flex items-center gap-2">
//                                                                 <div className={`p-2 rounded-lg ${isUploaded ? "bg-emerald-100 text-emerald-600" : "bg-gray-100 text-gray-400"}`}>
//                                                                     <FiFileText size={14} />
//                                                                 </div>
//                                                                 <div>
//                                                                     <p className="text-[10px] font-bold text-gray-800 uppercase tracking-tight">{cat.title}</p>
//                                                                     {isUploaded ? (
//                                                                         <p className="text-[8px] font-bold text-emerald-600 uppercase tracking-widest flex items-center gap-1">
//                                                                             <FiCheckCircle size={8} /> Uploaded
//                                                                         </p>
//                                                                     ) : (
//                                                                         <p className="text-[8px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1">
//                                                                             <FiAlertTriangle size={8} /> Missing
//                                                                         </p>
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                             {isUploaded && (
//                                                                 <div className="flex gap-1">
//                                                                     <button
//                                                                         onClick={() => window.open(formatDocUrl(doc.url), '_blank')}
//                                                                         className="px-3 py-1 bg-white border border-slate-200 text-slate-700 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-slate-600 hover:text-white transition-all shadow-sm"
//                                                                         title="View"
//                                                                     >
//                                                                         <FiEye size={10} />
//                                                                     </button>
//                                                                     <button
//                                                                         onClick={() => {
//                                                                             const link = document.createElement('a');
//                                                                             link.href = formatDocUrl(doc.url);
//                                                                             link.download = `${cat.title}_${selectedCandidate.firstName}.pdf`;
//                                                                             document.body.appendChild(link);
//                                                                             link.click();
//                                                                             document.body.removeChild(link);
//                                                                         }}
//                                                                         className="px-3 py-1 bg-white border border-emerald-200 text-emerald-700 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-emerald-600 hover:text-white transition-all shadow-sm"
//                                                                         title="Download"
//                                                                     >
//                                                                         <FiDownload size={10} />
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     );
//                                                 })}
//                                             </div>

//                                             {/* Bank Details */}
//                                             <div className="p-4 bg-blue-50/50 rounded-xl border border-blue-100">
//                                                 <h4 className="text-[10px] font-black uppercase text-blue-700 mb-3 tracking-widest flex items-center gap-2">
//                                                     <FiAward /> Bank Details
//                                                 </h4>
//                                                 {personalDocs.documents?.bankDetails?.bankName ? (
//                                                     <div className="grid grid-cols-3 gap-4">
//                                                         <div>
//                                                             <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Bank Name</p>
//                                                             <p className="text-xs font-bold text-gray-800 uppercase">{personalDocs.documents.bankDetails.bankName}</p>
//                                                         </div>
//                                                         <div>
//                                                             <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">A/C Number</p>
//                                                             <p className="text-xs font-bold text-gray-800 font-mono tracking-wider">
//                                                                 {personalDocs.documents.bankDetails.accountNumber}
//                                                             </p>
//                                                         </div>
//                                                         <div>
//                                                             <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">IFSC Code</p>
//                                                             <p className="text-xs font-bold text-gray-800 tracking-widest">{personalDocs.documents.bankDetails.ifscCode}</p>
//                                                         </div>
//                                                     </div>
//                                                 ) : (
//                                                     <p className="text-center py-2 text-[9px] font-bold text-blue-400 uppercase italic">Bank info not provided yet</p>
//                                                 )}
//                                             </div>

//                                             {/* Emergency Contact */}
//                                             <div className="p-4 bg-rose-50/50 rounded-xl border border-rose-100">
//                                                 <h4 className="text-[10px] font-black uppercase text-rose-700 mb-3 tracking-widest flex items-center gap-2">
//                                                     <FiUsers /> Emergency Contacts
//                                                 </h4>
//                                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                                     {[1, 2].map(num => {
//                                                         const contact = personalDocs.documents?.[`emergencyContact${num}`];
//                                                         return (
//                                                             <div key={num} className="bg-white/60 p-3 rounded-lg border border-rose-100/50">
//                                                                 <p className="text-[8px] font-black text-rose-400 uppercase mb-2 tracking-widest">Contact #{num}</p>
//                                                                 {contact?.name ? (
//                                                                     <div className="space-y-1">
//                                                                         <p className="text-xs font-bold text-gray-800 uppercase">{contact.name}</p>
//                                                                         <div className="flex items-center justify-between">
//                                                                             <p className="text-[10px] font-bold text-gray-500 font-mono">{contact.phone}</p>
//                                                                             <span className="text-[9px] font-bold text-rose-600 bg-rose-100 px-2 py-0.5 rounded uppercase">{contact.relationship}</span>
//                                                                         </div>
//                                                                     </div>
//                                                                 ) : (
//                                                                     <p className="text-[9px] font-bold text-rose-300 uppercase italic">Contact {num} not provided</p>
//                                                                 )}
//                                                             </div>
//                                                         );
//                                                     })}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div className="text-center p-12 bg-gray-50 rounded-lg border border-dashed border-gray-200">
//                                             <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-gray-300">
//                                                 <FiAlertTriangle size={24} />
//                                             </div>
//                                             <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">No Personal documents records found</p>
//                                             <p className="text-[8px] text-gray-400 mt-1 uppercase italic tracking-tighter">Candidate may not have started the document upload process yet</p>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div className="flex justify-end p-6 pt-0">
//                                 <button
//                                     className="px-6 py-2 text-slate-500 font-bold text-xs uppercase tracking-widest hover:bg-slate-100 rounded"
//                                     onClick={() => setIsDocsModalOpen(false)}
//                                 >
//                                     Close
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* ========================================= */}
//                 {/* Assessment Detail Modal - Same as before */}
//                 {/* ========================================= */}
//                 {isAssessmentModalOpen && selectedAssessmentData && (
//                     <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
//                         <div className="bg-white max-w-4xl w-full rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100 max-h-[90vh] flex flex-col">
//                             <div className="px-8 pt-8 pb-6 border-b border-gray-100 flex-shrink-0">
//                                 <div className="flex items-start justify-between">
//                                     <div>
//                                         <h2 className="text-xl text-gray-800 font-bold flex items-center gap-2">
//                                             Assessment Answer Sheets
//                                         </h2>
//                                         <p className="text-[10px] font-bold uppercase tracking-widest mt-1.5 text-gray-500">
//                                             Candidate: <span className="text-indigo-600">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
//                                         </p>
//                                     </div>
//                                     <button
//                                         onClick={() => setIsAssessmentModalOpen(false)}
//                                         className="p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
//                                     >
//                                         <FiX className="text-lg" />
//                                     </button>
//                                 </div>
//                             </div>

//                             <div className="p-8 overflow-y-auto space-y-12 flex-grow bg-white">
//                                 {Array.isArray(selectedAssessmentData) && selectedAssessmentData.length > 0 ? (
//                                     selectedAssessmentData.map((assessment, aIdx) => (
//                                         <div key={aIdx} className="space-y-6">
//                                             <div className="flex items-center justify-between pb-2 border-b-2 border-indigo-100">
//                                                 <h3 className="text-lg font-black text-indigo-900">{assessment.quizTitle}</h3>
//                                                 <div className="flex items-center gap-4">
//                                                     <div className="flex items-center gap-1">
//                                                         <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Score:</span>
//                                                         <span className={`text-sm font-black ${assessment.score >= 70 ? 'text-emerald-600' : assessment.score >= 50 ? 'text-amber-600' : 'text-rose-600'}`}>
//                                                             {assessment.score}
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             <div className="space-y-6">
//                                                 {assessment.answers && assessment.answers.length > 0 ? (
//                                                     assessment.answers.map((ans, idx) => {
//                                                         const optionLabels = ["A", "B", "C", "D", "E", "F", "G", "H"];
//                                                         const options = ans.options && ans.options.length > 0
//                                                             ? ans.options
//                                                             : [ans.selectedOption, ans.correctAnswer].filter(Boolean);

//                                                         return (
//                                                             <div key={idx} className="bg-white rounded-xl border border-gray-200 shadow-[0_2px_10px_-3px_rgba(6,81,237,0.1)] overflow-hidden">
//                                                                 <div className="flex items-start gap-3 px-5 py-4 border-b border-gray-100 bg-gray-50/50">
//                                                                     <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 font-black text-xs ${ans.isCorrect ? 'bg-emerald-100 text-emerald-600' : 'bg-rose-100 text-rose-600'}`}>
//                                                                         Q{idx + 1}
//                                                                     </div>
//                                                                     <div className="flex-grow pt-1">
//                                                                         <p className="text-sm font-bold text-gray-800 leading-relaxed">{ans.questionText}</p>
//                                                                     </div>
//                                                                     <div className="shrink-0 pt-1.5 flex items-center gap-1.5">
//                                                                         {ans.isCorrect ? (
//                                                                             <span className="text-[10px] font-black uppercase text-emerald-600 flex items-center gap-1">✓ Correct</span>
//                                                                         ) : (
//                                                                             <span className="text-[10px] font-black uppercase text-rose-600 flex items-center gap-1">✗ Incorrect</span>
//                                                                         )}
//                                                                     </div>
//                                                                 </div>

//                                                                 <div className="p-5 space-y-2.5">
//                                                                     {options.map((opt, oIdx) => {
//                                                                         const isCorrectOpt = String(opt).trim() === String(ans.correctAnswer).trim();
//                                                                         const isCandidateOpt = String(opt).trim() === String(ans.selectedOption).trim();
//                                                                         const label = optionLabels[oIdx] || String(oIdx + 1);

//                                                                         let optStyle = "bg-white border-gray-200 text-gray-600";
//                                                                         let radioStyle = "border-gray-200 border-2";
//                                                                         let badge = null;

//                                                                         if (isCorrectOpt && isCandidateOpt) {
//                                                                             optStyle = "bg-emerald-50/50 border-emerald-300 text-emerald-800";
//                                                                             radioStyle = "border-emerald-500 bg-emerald-500";
//                                                                             badge = <span className="text-[9px] font-black text-emerald-600 bg-emerald-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✓ Selected Correctly</span>;
//                                                                         } else if (isCorrectOpt) {
//                                                                             optStyle = "bg-emerald-50/30 border-emerald-200 text-emerald-700 border-dashed";
//                                                                             radioStyle = "border-emerald-400 border-2";
//                                                                             badge = <span className="text-[9px] font-black text-emerald-600 bg-emerald-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✓ Correct Answer</span>;
//                                                                         } else if (isCandidateOpt) {
//                                                                             optStyle = "bg-rose-50/50 border-rose-300 text-rose-800";
//                                                                             radioStyle = "border-rose-500 bg-rose-500";
//                                                                             badge = <span className="text-[9px] font-black text-rose-600 bg-rose-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✗ Selected Incorrectly</span>;
//                                                                         }

//                                                                         return (
//                                                                             <div key={oIdx} className={`flex items-center gap-4 px-4 py-3 rounded-xl border transition-all ${optStyle}`}>
//                                                                                 <div className="shrink-0">
//                                                                                     <span className="text-[10px] font-black text-gray-400 bg-gray-50 border border-gray-100 px-2 py-0.5 rounded uppercase">{label}</span>
//                                                                                 </div>
//                                                                                 <div className={`w-4 h-4 rounded-full flex items-center justify-center shrink-0 ${radioStyle}`}>
//                                                                                     {(isCandidateOpt || isCorrectOpt) && (
//                                                                                         <div className={`w-1.5 h-1.5 rounded-full ${isCorrectOpt && !isCandidateOpt ? 'bg-emerald-400' : 'bg-white'}`} />
//                                                                                     )}
//                                                                                 </div>
//                                                                                 <p className="text-xs font-semibold flex-grow">{opt}</p>
//                                                                                 {badge && (
//                                                                                     <div className="shrink-0 flex items-center justify-end min-w-[120px]">
//                                                                                         {badge}
//                                                                                     </div>
//                                                                                 )}
//                                                                             </div>
//                                                                         );
//                                                                     })}
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     })
//                                                 ) : (
//                                                     <p className="text-xs text-gray-500 italic">No detailed answers available for this assessment.</p>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div className="text-center py-20 bg-gray-50 rounded-xl border border-gray-100 flex flex-col items-center justify-center">
//                                         <div className="w-16 h-16 bg-white text-gray-300 rounded-full flex items-center justify-center mb-4 border border-gray-100 shadow-sm">
//                                             <FiEye className="text-3xl" />
//                                         </div>
//                                         <p className="text-gray-800 font-bold mb-1">No detailed analysis available</p>
//                                         <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest max-w-xs">Old assessment record without question tracking</p>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="px-8 py-4 border-t border-gray-100 bg-gray-50 flex justify-end flex-shrink-0">
//                                 <button
//                                     onClick={() => setIsAssessmentModalOpen(false)}
//                                     className="px-6 py-2.5 bg-white border border-gray-200 text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-lg font-bold text-xs uppercase tracking-widest transition-all shadow-[0_2px_4px_rgba(0,0,0,0.02)]"
//                                 >
//                                     Close View
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* ========================================= */}
//                 {/* Salary Package Modal - Same as before */}
//                 {/* ========================================= */}
//                 {isPackageModalOpen && (
//                     <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
//                         <div className="bg-white rounded-2xl max-w-2xl w-full p-6 shadow-2xl relative animate-in fade-in zoom-in duration-300">
//                             <button
//                                 onClick={() => setIsPackageModalOpen(false)}
//                                 className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
//                             >
//                                 <FiX />
//                             </button>

//                             <div className="text-center mb-8">
//                                 <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
//                                     <FiBriefcase size={28} />
//                                 </div>
//                                 <h2 className="text-2xl font-black text-gray-800">Salary Package</h2>
//                                 <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest mt-1">Negotiation & Finalization</p>
//                             </div>

//                             <div className="space-y-4">
//                                 <div className="grid grid-cols-2 gap-4">
//                                     <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
//                                         <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Budget Salary</p>
//                                         <p className="text-sm font-bold text-gray-800">{selectedCandidate?.jobId?.salary || "N/A"}</p>
//                                     </div>
//                                     <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
//                                         <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Previous Salary</p>
//                                         <p className="text-sm font-bold text-gray-800">{selectedCandidate?.currentCTC || "N/A"}</p>
//                                     </div>
//                                 </div>

//                                 <div className="grid grid-cols-2 gap-4">
//                                     <div>
//                                         <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Final Agreed Salary</label>
//                                         <div className="relative">
//                                             <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-bold">₹</div>
//                                             <input
//                                                 type="text"
//                                                 placeholder="e.g. 12,00,000"
//                                                 className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
//                                                 value={packageSalary}
//                                                 onChange={(e) => setPackageSalary(e.target.value)}
//                                             />
//                                         </div>
//                                     </div>

//                                     <div>
//                                         <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Joining Date</label>
//                                         <div className="relative">
//                                             <input
//                                                 type="date"
//                                                 className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
//                                                 value={packageJoiningDate}
//                                                 onChange={(e) => setPackageJoiningDate(e.target.value)}
//                                                 onClick={(e) => e.target.showPicker && e.target.showPicker()}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="grid grid-cols-2 gap-4">
//                                     <div>
//                                         <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Notice Period</label>
//                                         <select
//                                             className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800 appearance-none"
//                                             value={packageNoticePeriod}
//                                             onChange={(e) => setPackageNoticePeriod(e.target.value)}
//                                         >
//                                             <option value="">Select Notice Period</option>
//                                             <option value="10 Days">10 Days</option>
//                                             <option value="15 Days">15 Days</option>
//                                             <option value="20 Days">20 Days</option>
//                                             <option value="30 Days">30 Days</option>
//                                             <option value="60 Days">60 Days</option>
//                                         </select>
//                                     </div>
//                                     <div>
//                                         <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Probation Period</label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. 6 Months"
//                                             className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
//                                             value={packageProbationPeriod}
//                                             onChange={(e) => setPackageProbationPeriod(e.target.value)}
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="grid grid-cols-2 gap-4">
//                                     <div>
//                                         <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Daily Allowance (Optional)</label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. ₹500 or NA"
//                                             className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
//                                             value={packageDailyAllowance}
//                                             onChange={(e) => setPackageDailyAllowance(e.target.value)}
//                                         />
//                                     </div>
//                                     <div>
//                                         <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Perf. Allowance (Optional)</label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. ₹2000 or NA"
//                                             className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
//                                             value={packagePerformanceAllowance}
//                                             onChange={(e) => setPackagePerformanceAllowance(e.target.value)}
//                                         />
//                                     </div>
//                                 </div>

//                                 <p className="text-[9px] text-gray-400 mt-1 px-1 font-medium italic">* These values will be used in the official offer letter.</p>

//                                 <button
//                                     onClick={handleSavePackage}
//                                     className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-2xl font-black text-xs uppercase tracking-[0.2em] shadow-lg shadow-blue-200 hover:shadow-blue-300 hover:-translate-y-0.5 transition-all duration-300 mt-2"
//                                 >
//                                     Save Package Details
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* ========================================= */}
//                 {/* Document History Modal - Same as before */}
//                 {/* ========================================= */}
//                 {isHistoryModalOpen && selectedCandidate && (
//                     <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
//                         <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
//                             <button
//                                 onClick={() => setIsHistoryModalOpen(false)}
//                                 className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
//                             >
//                                 <FiX className="text-lg" />
//                             </button>
//                             <div className="px-8 pt-8 pb-4">
//                                 <h2 className="text-xl text-gray-800">Document Sent History</h2>
//                                 <p className="text-[10px] font-bold uppercase tracking-widest mt-1">
//                                     Candidate: {selectedCandidate.firstName} {selectedCandidate.lastName}
//                                 </p>
//                             </div>
//                             <div className="p-8 pt-4 max-h-[70vh] overflow-y-auto">
//                                 {selectedCandidate.documentHistory && selectedCandidate.documentHistory.length > 0 ? (
//                                     <div className="space-y-4">
//                                         {selectedCandidate.documentHistory.map((item, index) => (
//                                             <div key={item._id || index} className="p-4 bg-gray-50 rounded-2xl border border-gray-100 flex items-center justify-between group hover:bg-white hover:shadow-lg transition-all duration-300">
//                                                 <div className="flex items-center gap-4">
//                                                     <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-lg ${item.documentType === 'Offer' ? 'bg-green-100 text-green-600' :
//                                                             item.documentType === 'Agreement' ? 'bg-blue-100 text-blue-600' :
//                                                                 'bg-gray-100 text-gray-600'
//                                                         }`}>
//                                                         <FiFileText />
//                                                     </div>
//                                                     <div>
//                                                         <div className="flex items-center gap-2">
//                                                             <span className="text-sm font-black text-gray-800 uppercase tracking-tight">{item.documentType} Letter</span>
//                                                             <span className="text-[10px] font-bold text-gray-400">Sent on {new Date(item.sentAt).toLocaleDateString()} at {new Date(item.sentAt).toLocaleTimeString()}</span>
//                                                         </div>
//                                                         <div className="mt-1 text-xs text-gray-500 line-clamp-1 max-w-md italic">
//                                                             "{item.content?.replace(/<[^>]*>?/gm, '').substring(0, 100)}..."
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="flex items-center gap-2">
//                                                     {item.attachmentPath && (
//                                                         <>
//                                                             <button
//                                                                 onClick={() => window.open(formatDocUrl(item.attachmentPath), "_blank")}
//                                                                 className="px-4 py-2 bg-gray-100 text-gray-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-gray-200 transition-all flex items-center gap-2"
//                                                                 title="View Document"
//                                                             >
//                                                                 <FiEye size={12} /> View
//                                                             </button>
//                                                             <button
//                                                                 onClick={() => {
//                                                                     const link = document.createElement('a');
//                                                                     link.href = formatDocUrl(item.attachmentPath);
//                                                                     link.download = `${item.documentType}_Letter.pdf`;
//                                                                     document.body.appendChild(link);
//                                                                     link.click();
//                                                                     document.body.removeChild(link);
//                                                                 }}
//                                                                 className="px-4 py-2 bg-emerald-50 text-emerald-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-emerald-100 transition-all flex items-center gap-2"
//                                                                 title="Download Document"
//                                                             >
//                                                                 <FiDownload size={12} /> Download
//                                                             </button>
//                                                         </>
//                                                     )}
//                                                     <button
//                                                         disabled={historyLoading}
//                                                         onClick={() => handleDeleteHistoryItem(item._id)}
//                                                         className="p-2 text-rose-400 hover:text-rose-600 hover:bg-rose-50 rounded-xl transition-all"
//                                                         title="Delete History Entry"
//                                                     >
//                                                         <FiTrash2 size={14} />
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 ) : (
//                                     <div className="text-center py-20 bg-gray-50 rounded-3xl border border-dashed border-gray-200">
//                                         <div className="w-16 h-16 bg-white text-gray-300 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
//                                             <FiClock size={32} />
//                                         </div>
//                                         <h3 className="text-lg font-black text-gray-800 uppercase tracking-tight">No history found</h3>
//                                         <p className="text-xs text-gray-400 font-bold uppercase tracking-widest mt-1">No documents have been sent to this candidate yet.</p>
//                                     </div>
//                                 )}
//                             </div>
//                             <div className="p-6 bg-gray-50 border-t border-gray-100 flex justify-end">
//                                 <button
//                                     onClick={() => setIsHistoryModalOpen(false)}
//                                     className="px-8 py-2 bg-white text-gray-700 border border-gray-200 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-50 transition-all shadow-sm"
//                                 >
//                                     Close History
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </main>
//         </div>
//     );
// };

// export default Score;



import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
    FiBriefcase,
    FiCalendar,
    FiCheckCircle,
    FiMail,
    FiAlertTriangle,
    FiEye,
    FiFileText,
    FiMapPin,
    FiPhone,
    FiStar,
    FiX,
    FiClock,
    FiTrash2,
    FiDownload,
    FiAward,
    FiUsers,
    FiUser,
    FiTrendingUp,
    FiClipboard,
    FiFilter,
    FiSearch,
    FiBell,
    FiSend
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "./EmployeeDashboard.css";
import { formatSecondsToTime, getAssessmentTimeTaken, getCandidateTotalTimeTaken } from "../utils/assessmentTime";

const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

const DetailItem = ({ icon, label, value }) => (
    <div className="emp-dash__detail-row">
        <span className="emp-dash__detail-label">{label}</span>
        <span className="emp-dash__detail-value">{value || "N/A"}</span>
    </div>
);

const Score = () => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [scoreFilter, setScoreFilter] = useState(0);
    const [roleFilter, setRoleFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [statuses, setStatuses] = useState([]);
    const [roles, setRoles] = useState([]);
    const [roleSearchQuery, setRoleSearchQuery] = useState("");
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
    const [showMobileFilters, setShowMobileFilters] = useState(false);

    const roleDropdownRef = useRef(null);
    const statusDropdownRef = useRef(null);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const [inviteForm, setInviteForm] = useState({
        subject: "Interview Invitation - Timely Health",
        time: "",
        interviewMode: "Online",
        interviewAddress: "",
    });

    const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
    const [reminderSending, setReminderSending] = useState(false);
    const [reminderForm, setReminderForm] = useState({
        subject: "",
        time: "",
        interviewMode: "Online",
        interviewAddress: "",
        note: "",
    });

    const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
    const [isBulkReminderModalOpen, setIsBulkReminderModalOpen] = useState(false);
    const [bulkReminderSending, setBulkReminderSending] = useState(false);
    const [bulkReminderForm, setBulkReminderForm] = useState({
        subject: "Interview Reminder - Timely Health",
        note: "This is a friendly reminder regarding your upcoming interview. Please make sure to be available 5 minutes prior to the scheduled time.",
    });

    const [locations, setLocations] = useState([]);
    const [isDocsModalOpen, setIsDocsModalOpen] = useState(false);
    const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);
    const [selectedAssessmentData, setSelectedAssessmentData] = useState(null);
    const [docsForm, setDocsForm] = useState({
        agreementsContent: "Please read, sign, and re-upload this agreement for next steps.",
    });
    const [personalDocs, setPersonalDocs] = useState(null);
    const [personalDocsLoading, setPersonalDocsLoading] = useState(false);

    const [quizzes, setQuizzes] = useState([]);

    const formatDocUrl = (url) => {
        if (!url) return "";
        const cleanUrl = url.startsWith("/") ? url : `/${url}`;
        return `${API_BASE_URL.replace("/api", "")}${cleanUrl.replace(/\\/g, "/")}`;
    };

    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10,
    });

    const [isPackageModalOpen, setIsPackageModalOpen] = useState(false);
    const [packageSalary, setPackageSalary] = useState("");
    const [packageJoiningDate, setPackageJoiningDate] = useState("");
    const [packageNoticePeriod, setPackageNoticePeriod] = useState("");
    const [packageProbationPeriod, setPackageProbationPeriod] = useState("");
    const [packageDailyAllowance, setPackageDailyAllowance] = useState("");
    const [packagePerformanceAllowance, setPackagePerformanceAllowance] = useState("");
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(false);

    const navigate = useNavigate();

    const getClientId = () => {
        return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
    };

    useEffect(() => {
        fetchCandidates();
        fetchQuizzes();
        fetchLocations();
        fetchRoles();

        const handleClickOutside = (event) => {
            if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
                setIsRoleDropdownOpen(false);
            }
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setIsStatusDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchRoles = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/jobs/all/${clientId}`;
            } else {
                url = `${API_BASE_URL}/jobs/all`;
            }
            const res = await axios.get(url);
            if (res.data.success) {
                const rolesData = res.data.jobPosts || [];
                const formattedRoles = rolesData.map((job, index) => ({
                    _id: job._id || index,
                    name: job.role
                }));
                const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
                    .filter(name => name && !name.toLowerCase().includes("resign"))
                    .map(name => formattedRoles.find(r => r.name === name));
                setRoles(uniqueRoles);
            }
        } catch (err) {
            console.error("Failed to fetch roles:", err);
        }
    };

    const fetchLocations = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/location/alllocation?clientId=${clientId}`;
            } else {
                url = `${API_BASE_URL}/location/alllocation`;
            }
            const res = await axios.get(url);
            if (res.data?.locations) setLocations(res.data.locations);
        } catch (err) {
            console.error("Failed to fetch locations:", err);
        }
    };

    const fetchQuizzes = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/admin/getallquizes/${clientId}`;
            } else {
                url = `${API_BASE_URL}/admin/getallquizes`;
            }
            const res = await axios.get(url);
            if (res.data?.quizzes) setQuizzes(res.data.quizzes);
        } catch (err) {
            console.error("Failed to fetch quizzes:", err);
        }
    };

    // ✅ FIX: fetchCandidates with default rating set to 0
    const fetchCandidates = async () => {
        try {
            setLoading(true);
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/applications/all/${clientId}`;
            } else {
                url = `${API_BASE_URL}/applications/all`;
            }
            const res = await axios.get(url);
            if (res.data.success) {
                const applications = (res.data.applications || []).map(app => ({
                    ...app,
                    overallRating: app.overallRating !== undefined && app.overallRating !== null ? app.overallRating : 0,
                    appearanceScore: app.appearanceScore !== undefined && app.appearanceScore !== null ? app.appearanceScore : 0,
                    workKnowledge: app.workKnowledge !== undefined && app.workKnowledge !== null ? app.workKnowledge : 0,
                    technicalScore: app.technicalScore !== undefined && app.technicalScore !== null ? app.technicalScore : 0,
                }));
                setCandidates(applications);
            }
        } catch (err) {
            setError("Failed to fetch candidates score data");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateScore = async (id, field, value) => {
        const numericValue = (field === "status") ? value : Number(value);
        const clientId = getClientId();

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
                applicationId: id,
                clientId: clientId,
                [field]: numericValue,
            });
            if (res.data.success) {
                setCandidates((prev) =>
                    prev.map((c) => (c._id === id ? { ...c, [field]: numericValue } : c))
                );
            }
        } catch (err) {
            console.error("Update score error:", err);
        }
    };

    const handleOpenInviteModal = (candidate) => {
        setSelectedCandidate(candidate);
        setInviteForm({
            subject: candidate.interviewSubject || "Interview Invitation - Timely Health",
            time: candidate.interviewTime || "",
            interviewMode: candidate.interviewMode || "Online",
            interviewAddress: candidate.interviewAddress || "",
        });
        setIsInviteModalOpen(true);
    };

    const handleSendInvite = async () => {
        if (!inviteForm.time || !inviteForm.subject) {
            alert("Please fill in all fields");
            return;
        }

        const clientId = getClientId();

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/send-invitation`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                interviewSubject: inviteForm.subject,
                interviewTime: inviteForm.time,
                interviewMode: inviteForm.interviewMode,
                interviewAddress: inviteForm.interviewAddress,
            });

            if (res.data.success) {
                alert("Interview invitation sent successfully! You can now also send interview reminders to this candidate.");
                setIsInviteModalOpen(false);
                fetchCandidates();
            }
        } catch (err) {
            console.error("Send invite error:", err);
            alert("Failed to send invitation");
        }
    };

    const handleOpenReminderModal = (candidate) => {
        setSelectedCandidate(candidate);
        setReminderForm({
            subject: candidate.interviewSubject ? `Interview Reminder - ${candidate.interviewSubject}` : "Interview Reminder - Timely Health",
            time: candidate.interviewTime || "",
            interviewMode: candidate.interviewMode || "Online",
            interviewAddress: candidate.interviewAddress || "",
            note: "Please be available 5 minutes prior to the scheduled interview time. Feel free to reach out if you have any questions.",
        });
        setIsReminderModalOpen(true);
    };

    const handleSendReminder = async () => {
        if (!selectedCandidate) return;
        setReminderSending(true);

        const clientId = getClientId();
        const payload = {
            applicationId: selectedCandidate._id,
            clientId: clientId,
            interviewSubject: reminderForm.subject,
            interviewTime: reminderForm.time,
            interviewMode: reminderForm.interviewMode,
            interviewAddress: reminderForm.interviewAddress,
            reminderNote: reminderForm.note,
        };

        try {
            let sent = false;
            try {
                const res = await axios.post(`${API_BASE_URL}/applications/send-interview-reminder`, payload);
                if (res.data.success) sent = true;
            } catch (primaryErr) {
                // If remote backend returned 404 (endpoint not yet deployed to remote server)
                if (primaryErr.response?.status === 404) {
                    try {
                        const localRes = await axios.post(`https://ingrainhirebackend.ingrainsystems.com/api/applications/send-interview-reminder`, payload);
                        if (localRes.data.success) sent = true;
                    } catch (localErr) {
                        // Fallback: send-invitation with [REMINDER] subject on API_BASE_URL
                        const fallbackRes = await axios.post(`${API_BASE_URL}/applications/send-invitation`, {
                            applicationId: selectedCandidate._id,
                            clientId: clientId,
                            interviewSubject: reminderForm.subject.startsWith("[REMINDER]") ? reminderForm.subject : `[REMINDER] ${reminderForm.subject}`,
                            interviewTime: reminderForm.time,
                            interviewMode: reminderForm.interviewMode,
                            interviewAddress: reminderForm.interviewAddress,
                        });
                        if (fallbackRes.data.success) sent = true;
                    }
                } else {
                    throw primaryErr;
                }
            }

            if (sent) {
                alert(`Interview reminder sent successfully to ${selectedCandidate.firstName} ${selectedCandidate.lastName}!`);
                setIsReminderModalOpen(false);
                fetchCandidates();
            } else {
                alert("Failed to send reminder. Please try again.");
            }
        } catch (err) {
            console.error("Send reminder error:", err);
            alert(err.response?.data?.message || "Failed to send interview reminder.");
        } finally {
            setReminderSending(false);
        }
    };

    const isCandidateScheduled = (candidate) => {
        return candidate.status === "Interview" && (
            candidate.interviewStatus === 'Invited' ||
            candidate.interviewStatus === 'Rescheduled' ||
            Boolean(candidate.interviewTime)
        );
    };

    const handleToggleSelectCandidate = (candidateId) => {
        setSelectedCandidateIds((prev) =>
            prev.includes(candidateId) ? prev.filter((id) => id !== candidateId) : [...prev, candidateId]
        );
    };

    const handleSelectAllScheduled = () => {
        const scheduledInView = currentItems.filter(isCandidateScheduled).map((c) => c._id);
        const allSelected = scheduledInView.length > 0 && scheduledInView.every((id) => selectedCandidateIds.includes(id));

        if (allSelected) {
            setSelectedCandidateIds((prev) => prev.filter((id) => !scheduledInView.includes(id)));
        } else {
            setSelectedCandidateIds((prev) => Array.from(new Set([...prev, ...scheduledInView])));
        }
    };

    const handleOpenBulkReminderModal = () => {
        const scheduledCandidates = filteredCandidates.filter(isCandidateScheduled);

        if (scheduledCandidates.length === 0) {
            alert("No candidates with scheduled interviews found in the current list.");
            return;
        }

        if (selectedCandidateIds.length === 0) {
            setSelectedCandidateIds(scheduledCandidates.map((c) => c._id));
        }

        setBulkReminderForm({
            subject: "Interview Reminder - Timely Health",
            note: "This is a friendly reminder regarding your upcoming interview. Please make sure to be available 5 minutes prior to the scheduled time.",
        });
        setIsBulkReminderModalOpen(true);
    };

    const handleSendBulkReminder = async () => {
        if (selectedCandidateIds.length === 0) {
            alert("Please select at least one candidate to send reminder.");
            return;
        }

        setBulkReminderSending(true);

        const clientId = getClientId();
        const payload = {
            applicationIds: selectedCandidateIds,
            clientId: clientId,
            interviewSubject: bulkReminderForm.subject,
            reminderNote: bulkReminderForm.note,
        };

        try {
            let sent = false;
            try {
                const res = await axios.post(`${API_BASE_URL}/applications/send-bulk-interview-reminder`, payload);
                if (res.data.success) sent = true;
            } catch (primaryErr) {
                if (primaryErr.response?.status === 404) {
                    try {
                        const localRes = await axios.post(`https://ingrainhirebackend.ingrainsystems.com/api/applications/send-bulk-interview-reminder`, payload);
                        if (localRes.data.success) sent = true;
                    } catch (localErr) {
                        let successCount = 0;
                        for (const candId of selectedCandidateIds) {
                            const cand = candidates.find((c) => c._id === candId);
                            try {
                                await axios.post(`${API_BASE_URL}/applications/send-interview-reminder`, {
                                    applicationId: candId,
                                    clientId: clientId,
                                    interviewSubject: bulkReminderForm.subject,
                                    interviewTime: cand?.interviewTime || "",
                                    interviewMode: cand?.interviewMode || "Online",
                                    interviewAddress: cand?.interviewAddress || "",
                                    reminderNote: bulkReminderForm.note,
                                });
                                successCount++;
                            } catch (singleErr) {
                                try {
                                    await axios.post(`${API_BASE_URL}/applications/send-invitation`, {
                                        applicationId: candId,
                                        clientId: clientId,
                                        interviewSubject: bulkReminderForm.subject.startsWith("[REMINDER]") ? bulkReminderForm.subject : `[REMINDER] ${bulkReminderForm.subject}`,
                                        interviewTime: cand?.interviewTime || "",
                                        interviewMode: cand?.interviewMode || "Online",
                                        interviewAddress: cand?.interviewAddress || "",
                                    });
                                    successCount++;
                                } catch (invErr) {
                                    console.error("Bulk fallback error for cand", candId, invErr);
                                }
                            }
                        }
                        if (successCount > 0) sent = true;
                    }
                } else {
                    throw primaryErr;
                }
            }

            if (sent) {
                alert(`Bulk interview reminder sent successfully to ${selectedCandidateIds.length} candidate(s)!`);
                setIsBulkReminderModalOpen(false);
                setSelectedCandidateIds([]);
                fetchCandidates();
            } else {
                alert("Failed to send bulk reminders. Please try again.");
            }
        } catch (err) {
            console.error("Bulk reminder error:", err);
            alert(err.response?.data?.message || "Failed to send bulk interview reminders.");
        } finally {
            setBulkReminderSending(false);
        }
    };

    const handleOpenOfferModal = (candidate) => {
        navigate(`/send-offer?id=${candidate._id}&email=${candidate.email}`);
    };

    const handleOpenPackageModal = (candidate) => {
        setSelectedCandidate(candidate);
        setPackageSalary(candidate.finalSalary || candidate.expectedCTC || "");
        setPackageJoiningDate(candidate.dateOfJoining || "");
        setPackageNoticePeriod(candidate.noticePeriod || "");
        setPackageProbationPeriod(candidate.probationPeriod || "");
        setPackageDailyAllowance(candidate.dailyAllowance || "");
        setPackagePerformanceAllowance(candidate.performanceAllowance || "");
        setIsPackageModalOpen(true);
    };

    const handleOpenDetailsModal = (candidate) => {
        setSelectedCandidate(candidate);
        setIsDetailsModalOpen(true);
    };

    const handleSavePackage = async () => {
        const clientId = getClientId();
        try {
            const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                finalSalary: packageSalary,
                dateOfJoining: packageJoiningDate,
                noticePeriod: packageNoticePeriod,
                probationPeriod: packageProbationPeriod,
                dailyAllowance: packageDailyAllowance,
                performanceAllowance: packagePerformanceAllowance,
            });
            if (res.data.success) {
                alert("Package updated successfully!");
                setIsPackageModalOpen(false);
                fetchCandidates();
            }
        } catch (err) {
            console.error("Save package error:", err);
            alert("Failed to save package");
        }
    };

    const handleOpenDocsModal = async (candidate) => {
        setSelectedCandidate(candidate);
        setDocsForm({ agreementsContent: candidate.adminAgreements || "Please read, sign, and re-upload this agreement for next steps." });
        setIsDocsModalOpen(true);

        if (candidate.candidateId?._id || candidate.candidateId) {
            const candidateId = candidate.candidateId?._id || candidate.candidateId;
            const clientId = getClientId();
            try {
                setPersonalDocsLoading(true);
                const res = await axios.get(`${API_BASE_URL}/candidate/admin/${candidateId}?clientId=${clientId}`);
                if (res.data.success) {
                    setPersonalDocs(res.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch candidate documents:", err);
                setPersonalDocs(null);
            } finally {
                setPersonalDocsLoading(false);
            }
        }
    };

    const handleOpenHistoryModal = (candidate) => {
        setSelectedCandidate(candidate);
        setIsHistoryModalOpen(true);
    };

    const handleDeleteHistoryItem = async (historyId) => {
        if (!window.confirm("Are you sure you want to delete this history item?")) return;

        const clientId = getClientId();

        try {
            setHistoryLoading(true);
            const res = await axios.post(`${API_BASE_URL}/applications/delete-history-item`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                historyId: historyId
            });

            if (res.data.success) {
                alert("History item deleted successfully!");
                setSelectedCandidate(res.data.application);
                setCandidates(prev => prev.map(c => c._id === res.data.application._id ? res.data.application : c));
            }
        } catch (err) {
            console.error("Failed to delete history item:", err);
            alert("Failed to delete history item");
        } finally {
            setHistoryLoading(false);
        }
    };

    const handleOpenAssessmentDetails = (candidate) => {
        if (!candidate.assessmentResults || candidate.assessmentResults.length === 0) {
            alert("No assessment data available for this candidate.");
            return;
        }

        const allAssessments = candidate.assessmentResults.map((result, aIdx) => {
            let matchedQuiz = null;
            if (result.quizId && typeof result.quizId === 'object' && result.quizId.questions) {
                matchedQuiz = result.quizId;
            } else {
                const quizId = typeof result.quizId === 'object' ? result.quizId?._id : result.quizId;
                matchedQuiz = quizzes.find(q => String(q._id) === String(quizId));

                if (!matchedQuiz && candidate.comment) {
                    const titleMatch = candidate.comment.match(/"([^"]+)"/);
                    if (titleMatch?.[1]) {
                        matchedQuiz = quizzes.find(q => q.title === titleMatch[1]);
                    }
                }
            }

            let enrichedAnswers = [];

            if (matchedQuiz && matchedQuiz.questions && matchedQuiz.questions.length > 0) {
                enrichedAnswers = matchedQuiz.questions.map((q, idx) => {
                    const storedByText = result.answers?.find(a => a.questionText === q.questionText);
                    const storedByIndex = result.answers?.[idx];
                    const storedAns = storedByText || storedByIndex;

                    const selected = storedAns?.selectedOption || "Not Answered";
                    const correct = q.correctAnswer || "";

                    return {
                        questionText: q.questionText,
                        options: q.options || [],
                        correctAnswer: correct,
                        selectedOption: selected,
                        isCorrect: String(selected).trim() === String(correct).trim(),
                        marks: q.marks || 1,
                    };
                });
            } else if (result.answers && result.answers.length > 0) {
                enrichedAnswers = result.answers.map(ans => ({
                    questionText: ans.questionText || "Question",
                    options: ans.options?.length > 0
                        ? ans.options
                        : [ans.selectedOption, ans.correctAnswer].filter(Boolean),
                    correctAnswer: ans.correctAnswer || "",
                    selectedOption: ans.selectedOption || "Not Answered",
                    isCorrect: ans.isCorrect !== undefined
                        ? ans.isCorrect
                        : String(ans.selectedOption).trim() === String(ans.correctAnswer).trim(),
                    marks: ans.marks || 1
                }));
            }

            const quizTitle = matchedQuiz?.title || (typeof result.quizId === 'object' ? result.quizId?.title : null) || "Assessment";
            const resolvedTimeTaken = getAssessmentTimeTaken({ ...result, quizTitle }, aIdx, candidate.assessmentResults, candidate);

            return {
                ...result,
                timeTaken: result.timeTaken !== undefined && result.timeTaken !== null ? result.timeTaken : resolvedTimeTaken,
                answers: enrichedAnswers,
                quizTitle,
                quizId: matchedQuiz || result.quizId
            };
        });

        setSelectedAssessmentData(allAssessments);
        setSelectedCandidate(candidate);
        setIsAssessmentModalOpen(true);
    };

    const [docsFile, setDocsFile] = useState(null);

    const handleSendAgreements = async () => {
        const formData = new FormData();
        const clientId = getClientId();
        formData.append("applicationId", selectedCandidate._id);
        formData.append("clientId", clientId);
        formData.append("agreementsContent", docsForm.agreementsContent);
        if (docsFile) {
            formData.append("adminAttachment", docsFile);
        }

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/send-agreements`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (res.data.success) {
                alert("Agreements sent successfully!");
                setDocsFile(null);
                fetchCandidates();
            }
        } catch (err) {
            console.error(err);
            alert("Failed to send agreements");
        }
    };

    const handleReviewDocs = async (status) => {
        const clientId = getClientId();
        try {
            const res = await axios.post(`${API_BASE_URL}/applications/review-documents`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                status
            });
            if (res.data.success) {
                alert(`Documents ${status}`);
                setIsDocsModalOpen(false);
                fetchCandidates();
            }
        } catch (err) {
            console.error(err);
            alert("Failed to update status");
        }
    };

    // Helper functions for fuzzy search
    const normalize = (str) => (str || "").toLowerCase().replace(/\s+/g, "");
    const levenshtein = (a, b) => {
        const al = a.length;
        const bl = b.length;
        const dp = Array.from({ length: al + 1 }, () => Array(bl + 1).fill(0));
        for (let i = 0; i <= al; i++) dp[i][0] = i;
        for (let j = 0; j <= bl; j++) dp[0][j] = j;
        for (let i = 1; i <= al; i++) {
            for (let j = 1; j <= bl; j++) {
                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                dp[i][j] = Math.min(
                    dp[i - 1][j] + 1,
                    dp[i][j - 1] + 1,
                    dp[i - 1][j - 1] + cost
                );
            }
        }
        return dp[al][bl];
    };

    // ✅ FIX: Updated filteredCandidates with mobile number search
    const filteredCandidates = candidates.filter(c => {
        if (c.jobId?.role?.toLowerCase().includes("resign") || c.status === "Resigned" || c.documentType === "Resignation" || c.jobId?.jobType === "short") return false;

        const normQuery = normalize(searchQuery);
        const candidateName = `${c.firstName} ${c.lastName}`;
        const normName = normalize(candidateName);
        const role = c.jobId?.role || "";
        const normRole = normalize(role);
        const mobile = c.mobile || c.phone || "";
        const normMobile = normalize(mobile);
        const email = c.email || "";
        const normEmail = normalize(email);

        // Search matches: Name, Role, Mobile Number, or Email
        const nameMatch = normName.includes(normQuery) || levenshtein(normName, normQuery) <= 2;
        const roleMatch = normRole.includes(normQuery) || levenshtein(normRole, normQuery) <= 2;
        const mobileMatch = normMobile.includes(normQuery) || levenshtein(normMobile, normQuery) <= 2;
        const emailMatch = normEmail.includes(normQuery) || levenshtein(normEmail, normQuery) <= 2;
        const matchesSearch = nameMatch || roleMatch || mobileMatch || emailMatch;

        const matchesScore = (c.technicalScore || 0) >= scoreFilter;
        const matchesRole = roleFilter ? (c.jobId?.role === roleFilter) : true;
        const matchesDate = dateFilter ? new Date(c.appliedAt).toISOString().slice(0, 10) === dateFilter : true;
        const matchesStatus = statusFilter ? (c.status === statusFilter) : true;

        return matchesSearch && matchesScore && matchesRole && matchesDate && matchesStatus;
    });

    const handleItemsPerPageChange = (limit) => {
        setPagination({
            currentPage: 1,
            limit: limit,
            totalCount: filteredCandidates.length,
            totalPages: Math.ceil(filteredCandidates.length / limit)
        });
    };

    const handlePrevPage = () => {
        if (pagination.currentPage > 1) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage - 1
            }));
        }
    };

    const handleNextPage = () => {
        if (pagination.currentPage < pagination.totalPages) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage + 1
            }));
        }
    };

    const handlePageClick = (page) => {
        setPagination(prev => ({
            ...prev,
            currentPage: page
        }));
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= pagination.totalPages; i++) {
            if (
                i === 1 ||
                i === pagination.totalPages ||
                (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
            ) {
                pageNumbers.push(i);
            } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
                pageNumbers.push("...");
            }
        }
        return pageNumbers;
    };

    useEffect(() => {
        setPagination(prev => ({
            ...prev,
            totalCount: filteredCandidates.length,
            totalPages: Math.ceil(filteredCandidates.length / prev.limit),
            currentPage: 1
        }));
    }, [filteredCandidates.length, searchQuery, scoreFilter, roleFilter, dateFilter, statusFilter]);

    const indexOfLastItem = pagination.currentPage * pagination.limit;
    const indexOfFirstItem = indexOfLastItem - pagination.limit;
    const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);

    const resetFilters = () => {
        setSearchQuery("");
        setScoreFilter(0);
        setRoleFilter("");
        setRoleSearchQuery("");
        setDateFilter("");
        setStatusFilter("");
    };

    if (loading) return (
        <div style={{ backgroundColor: 'white' }} className="emp-dash">
            <main className="p-4 sm:p-6 lg:p-8">
                <div className="py-10 text-center">
                    <div className="flex flex-col items-center justify-center gap-3">
                        <div className="emp-dash__spinner"></div>
                        <span className="text-sm font-medium text-gray-500">Syncing score data...</span>
                    </div>
                </div>
            </main>
        </div>
    );

    return (
        <div style={{ backgroundColor: 'white' }} className="emp-dash">
            <main className="">
                {/* Dashboard Header */}
                <div className="emp-dash__header">
                    <div>
                        <h1 className="emp-dash__greeting">
                            Score <span>Board</span>
                        </h1>
                        <p className="emp-dash__subtitle">
                            Evaluate and manage candidate scores
                        </p>
                    </div>
                    <div className="emp-dash__date-pill">
                        <FiClipboard />
                        <span>
                            {new Date().toLocaleDateString("en-US", {
                                weekday: "short",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                            })}
                        </span>
                    </div>
                </div>

                {/* Top KPI Stats Grid */}
                <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4 mb-6">
                    <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
                        <div className="emp-dash__stat-top">
                            <span className="emp-dash__stat-label">Total Candidates</span>
                            <div className="emp-dash__stat-icon emp-dash__stat-icon--rate">
                                <FiUsers />
                            </div>
                        </div>
                        <div className="emp-dash__stat-value">{candidates.length}</div>
                        <div className="emp-dash__stat-meta">total applications</div>
                    </div>

                    <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
                        <div className="emp-dash__stat-top">
                            <span className="emp-dash__stat-label">Selected</span>
                            <div className="emp-dash__stat-icon emp-dash__stat-icon--present">
                                <FiCheckCircle />
                            </div>
                        </div>
                        <div className="emp-dash__stat-value">{candidates.filter((c) => c.status === "Selected").length}</div>
                        <div className="emp-dash__stat-meta">candidates selected</div>
                    </div>

                    <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
                        <div className="emp-dash__stat-top">
                            <span className="emp-dash__stat-label">Interview Stage</span>
                            <div className="emp-dash__stat-icon emp-dash__stat-icon--late">
                                <FiCalendar />
                            </div>
                        </div>
                        <div className="emp-dash__stat-value">{candidates.filter((c) => c.status === "Interview").length}</div>
                        <div className="emp-dash__stat-meta">in interview process</div>
                    </div>

                    <div className="emp-dash__stat cursor-pointer hover:scale-105 transition-transform duration-200">
                        <div className="emp-dash__stat-top">
                            <span className="emp-dash__stat-label">Filtered Results</span>
                            <div className="emp-dash__stat-icon emp-dash__stat-icon--rate">
                                <FiFilter />
                            </div>
                        </div>
                        <div className="emp-dash__stat-value">{filteredCandidates.length}</div>
                        <div className="emp-dash__stat-meta">matching filters</div>
                    </div>

                    <div className="emp-dash__stat col-span-2 lg:col-span-1 cursor-pointer hover:scale-105 transition-transform duration-200">
                        <div className="emp-dash__stat-top">
                            <span className="emp-dash__stat-label">Avg Technical Score</span>
                            <div className="emp-dash__stat-icon emp-dash__stat-icon--present">
                                <FiTrendingUp />
                            </div>
                        </div>
                        <div className="emp-dash__stat-value text-base sm:text-lg md:text-xl font-bold truncate">
                            {candidates.length > 0
                                ? Math.round(candidates.reduce((sum, c) => sum + (c.technicalScore || 0), 0) / candidates.length)
                                : 0}%
                        </div>
                        <div className="emp-dash__stat-meta">overall average</div>
                    </div>
                </div>

                {/* Filters Section */}
                <div className="emp-dash__card mb-6">
                    <div className="hidden lg:block">
                        <div className="flex items-center justify-between gap-3 p-3 bg-white rounded-xl border border-gray-200">
                            <div className="flex items-center gap-2 flex-1 min-w-0">
                                {/* Search - Updated placeholder */}
                                <div className="relative min-w-[140px] flex-1 max-w-[200px]">
                                    <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
                                    <input
                                        type="text"
                                        placeholder="Search Name, Role or Mobile..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
                                    />
                                </div>

                                {/* Role Filter */}
                                <div className="relative" ref={roleDropdownRef}>
                                    <button
                                        onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
                                        className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg border transition-all bg-white whitespace-nowrap ${roleFilter
                                            ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
                                            : "border-gray-300 text-gray-700 hover:bg-gray-50"
                                            }`}
                                    >
                                        <FiBriefcase className="text-gray-400 text-[10px]" />
                                        <span className="truncate max-w-[100px]">{roleFilter || "Roles"}</span>
                                        <span className="text-gray-400 text-[10px]">▾</span>
                                    </button>
                                    {isRoleDropdownOpen && (
                                        <div
                                            className="fixed bg-white border border-gray-200 rounded-lg shadow-2xl min-w-[200px] max-h-60 overflow-y-auto"
                                            style={{
                                                zIndex: 99999,
                                                top: roleDropdownRef.current ? roleDropdownRef.current.getBoundingClientRect().bottom + 4 : 'auto',
                                                left: roleDropdownRef.current ? roleDropdownRef.current.getBoundingClientRect().left : 'auto',
                                            }}
                                        >
                                            <div className="p-2 border-b border-gray-100 bg-gray-50">
                                                <div className="relative">
                                                    <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                                    <input
                                                        type="text"
                                                        className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                        placeholder="Search roles..."
                                                        value={roleSearchQuery}
                                                        onChange={(e) => setRoleSearchQuery(e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        autoFocus
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setRoleFilter('');
                                                    setIsRoleDropdownOpen(false);
                                                    setRoleSearchQuery('');
                                                }}
                                                className="px-3 py-2 text-xs font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
                                            >
                                                All Roles
                                            </div>
                                            {roles
                                                .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
                                                .map((r) => (
                                                    <div
                                                        key={r._id}
                                                        onClick={() => {
                                                            setRoleFilter(r.name);
                                                            setIsRoleDropdownOpen(false);
                                                            setRoleSearchQuery('');
                                                        }}
                                                        className={`px-3 py-2 text-xs cursor-pointer hover:bg-blue-50 ${roleFilter === r.name ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
                                                            }`}
                                                    >
                                                        {r.name}
                                                    </div>
                                                ))}
                                            {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
                                                <div className="px-3 py-2 text-xs text-gray-400 text-center">
                                                    No roles found
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Status Filter */}
                                <div className="relative" ref={statusDropdownRef}>
                                    <button
                                        onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
                                        className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg border transition-all bg-white whitespace-nowrap ${statusFilter
                                            ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
                                            : "border-gray-300 text-gray-700 hover:bg-gray-50"
                                            }`}
                                    >
                                        <FiCheckCircle className="text-gray-400 text-[10px]" />
                                        <span className="truncate max-w-[100px]">{statusFilter || "Status"}</span>
                                        <span className="text-gray-400 text-[10px]">▾</span>
                                    </button>
                                    {isStatusDropdownOpen && (
                                        <div
                                            className="fixed bg-white border border-gray-200 rounded-lg shadow-2xl min-w-[200px] max-h-60 overflow-y-auto"
                                            style={{
                                                zIndex: 99999,
                                                top: statusDropdownRef.current ? statusDropdownRef.current.getBoundingClientRect().bottom + 4 : 'auto',
                                                left: statusDropdownRef.current ? statusDropdownRef.current.getBoundingClientRect().left : 'auto',
                                            }}
                                        >
                                            <div
                                                onClick={() => {
                                                    setStatusFilter('');
                                                    setIsStatusDropdownOpen(false);
                                                }}
                                                className="px-3 py-2 text-xs font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
                                            >
                                                All Statuses
                                            </div>
                                            {['Pending', 'Shortlisted', 'Interview', 'Selected', 'Rejected'].map((status) => (
                                                <div
                                                    key={status}
                                                    onClick={() => {
                                                        setStatusFilter(status);
                                                        setIsStatusDropdownOpen(false);
                                                    }}
                                                    className={`px-3 py-2 text-xs cursor-pointer hover:bg-blue-50 ${statusFilter === status ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
                                                        }`}
                                                >
                                                    {status}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Score Filter */}
                                <div className="relative w-[130px]">
                                    <select
                                        className="w-full h-8 pl-3 pr-8 py-1.5 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white appearance-none transition-all"
                                        value={scoreFilter}
                                        onChange={(e) => setScoreFilter(Number(e.target.value))}
                                    >
                                        <option value="0">All Scores</option>
                                        <option value="60">60% & Above</option>
                                        <option value="70">70% & Above</option>
                                        <option value="80">80% & Above</option>
                                        <option value="90">90% & Above</option>
                                    </select>
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                        <FiStar className="text-xs text-gray-400" />
                                    </div>
                                </div>

                                {/* Date Filter */}
                                <div className="relative">
                                    <input
                                        type="date"
                                        value={dateFilter}
                                        onChange={(e) => setDateFilter(e.target.value)}
                                        onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                        className="w-[120px] h-8 px-2 py-1 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
                                    />
                                </div>
                            </div>

                            {/* Right - Action Buttons */}
                            <div className="flex items-center gap-1.5 flex-shrink-0">
                                <button
                                    onClick={handleOpenBulkReminderModal}
                                    className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 rounded-lg shadow-sm hover:shadow transition-all whitespace-nowrap"
                                    title="Send Interview Reminders to Multiple Candidates"
                                >
                                    <FiBell className="w-3.5 h-3.5" />
                                    <span>Bulk Reminder {selectedCandidateIds.length > 0 ? `(${selectedCandidateIds.length})` : ''}</span>
                                </button>
                                {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter || statusFilter) && (
                                    <button
                                        onClick={resetFilters}
                                        className="flex items-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all shadow-sm whitespace-nowrap"
                                    >
                                        <FiTrash2 className="w-3 h-3" />
                                        Clear
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Mobile View */}
                    <div className="lg:hidden">
                        <div className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-200">
                            <button
                                onClick={() => setShowMobileFilters(!showMobileFilters)}
                                className="flex items-center gap-2 text-sm font-semibold text-gray-700"
                            >
                                <FiFilter className="text-blue-600 text-base" />
                                <span>Filters &amp; Actions</span>
                                {showMobileFilters ? (
                                    <span className="text-gray-400">▲</span>
                                ) : (
                                    <span className="text-gray-400">▼</span>
                                )}
                            </button>
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={handleOpenBulkReminderModal}
                                    className="flex items-center gap-1 px-2.5 py-1 text-xs font-bold text-white bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 rounded-lg shadow-sm whitespace-nowrap"
                                    title="Send Interview Reminders to Multiple Candidates"
                                >
                                    <FiBell className="w-3 h-3" />
                                    <span>Bulk Reminder {selectedCandidateIds.length > 0 ? `(${selectedCandidateIds.length})` : ''}</span>
                                </button>
                                <span className="text-xs text-gray-500 whitespace-nowrap">
                                    <strong>{filteredCandidates.length}</strong>
                                </span>
                            </div>
                        </div>

                        {showMobileFilters && (
                            <div className="mt-2 p-4 bg-white rounded-xl border border-gray-200 space-y-3">
                                <div>
                                    <label className="block text-xs font-medium text-gray-600 mb-1">Search Name, Role or Mobile</label>
                                    <div className="relative">
                                        <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                                        <input
                                            type="text"
                                            placeholder="Search Name, Role or Mobile..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
                                        />
                                    </div>
                                </div>

                                <div className="relative" ref={roleDropdownRef}>
                                    <label className="block text-xs font-medium text-gray-600 mb-1">Role</label>
                                    <button
                                        onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
                                        className={`w-full flex items-center justify-between px-3 py-2.5 text-sm font-medium rounded-lg border transition-all bg-white ${roleFilter
                                            ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
                                            : "border-gray-300 text-gray-700"
                                            }`}
                                    >
                                        <span className="flex items-center gap-2">
                                            <FiBriefcase className="text-gray-400" />
                                            {roleFilter || "All Roles"}
                                        </span>
                                        <span className="text-gray-400">▾</span>
                                    </button>
                                    {isRoleDropdownOpen && (
                                        <div className="absolute left-0 right-0 z-50 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                            <div className="p-2 border-b border-gray-100 bg-gray-50">
                                                <div className="relative">
                                                    <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                                    <input
                                                        type="text"
                                                        className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                        placeholder="Search roles..."
                                                        value={roleSearchQuery}
                                                        onChange={(e) => setRoleSearchQuery(e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        autoFocus
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setRoleFilter('');
                                                    setIsRoleDropdownOpen(false);
                                                    setRoleSearchQuery('');
                                                }}
                                                className="px-3 py-2.5 text-sm font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
                                            >
                                                All Roles
                                            </div>
                                            {roles
                                                .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
                                                .map((r) => (
                                                    <div
                                                        key={r._id}
                                                        onClick={() => {
                                                            setRoleFilter(r.name);
                                                            setIsRoleDropdownOpen(false);
                                                            setRoleSearchQuery('');
                                                        }}
                                                        className={`px-3 py-2.5 text-sm cursor-pointer hover:bg-blue-50 ${roleFilter === r.name ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
                                                            }`}
                                                    >
                                                        {r.name}
                                                    </div>
                                                ))}
                                        </div>
                                    )}
                                </div>

                                <div className="relative" ref={statusDropdownRef}>
                                    <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                                    <button
                                        onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
                                        className={`w-full flex items-center justify-between px-3 py-2.5 text-sm font-medium rounded-lg border transition-all bg-white ${statusFilter
                                            ? "border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50"
                                            : "border-gray-300 text-gray-700"
                                            }`}
                                    >
                                        <span className="flex items-center gap-2">
                                            <FiCheckCircle className="text-gray-400" />
                                            {statusFilter || "All Statuses"}
                                        </span>
                                        <span className="text-gray-400">▾</span>
                                    </button>
                                    {isStatusDropdownOpen && (
                                        <div className="absolute left-0 right-0 z-50 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                            <div
                                                onClick={() => {
                                                    setStatusFilter('');
                                                    setIsStatusDropdownOpen(false);
                                                }}
                                                className="px-3 py-2.5 text-sm font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50"
                                            >
                                                All Statuses
                                            </div>
                                            {['Pending', 'Shortlisted', 'Interview', 'Selected', 'Rejected'].map((status) => (
                                                <div
                                                    key={status}
                                                    onClick={() => {
                                                        setStatusFilter(status);
                                                        setIsStatusDropdownOpen(false);
                                                    }}
                                                    className={`px-3 py-2.5 text-sm cursor-pointer hover:bg-blue-50 ${statusFilter === status ? "bg-blue-50 text-blue-700 font-semibold" : "text-gray-700"
                                                        }`}
                                                >
                                                    {status}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="grid grid-cols-2 gap-2">
                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Min Score</label>
                                        <select
                                            className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
                                            value={scoreFilter}
                                            onChange={(e) => setScoreFilter(Number(e.target.value))}
                                        >
                                            <option value="0">All Scores</option>
                                            <option value="60">60%+</option>
                                            <option value="70">70%+</option>
                                            <option value="80">80%+</option>
                                            <option value="90">90%+</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Date</label>
                                        <input
                                            type="date"
                                            value={dateFilter}
                                            onChange={(e) => setDateFilter(e.target.value)}
                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                            className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white"
                                        />
                                    </div>
                                </div>

                                <div className="pt-3 border-t border-gray-200">
                                    {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter || statusFilter) && (
                                        <button
                                            onClick={resetFilters}
                                            className="w-full flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all"
                                        >
                                            <FiTrash2 className="w-4 h-4" />
                                            Clear Filters
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {error && <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3">
                    <FiX className="text-red-500 text-lg" />
                    <span className="text-sm font-medium text-red-700">{error}</span>
                </div>}

                <div className="emp-dash__card mb-6">
                    {filteredCandidates.length > 0 ? (
                        <>
                            {/* Desktop Table View */}
                            <div className="emp-dash__table-wrap overflow-x-auto w-full hidden md:block">
                                <table className="emp-dash__table min-w-[800px] w-full">
                                    <thead>
                                        <tr>
                                            <th className="py-2 px-2 text-center w-10">
                                                <input
                                                    type="checkbox"
                                                    className="w-4 h-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500 cursor-pointer accent-amber-600"
                                                    checked={
                                                        currentItems.filter(isCandidateScheduled).length > 0 &&
                                                        currentItems.filter(isCandidateScheduled).every((c) => selectedCandidateIds.includes(c._id))
                                                    }
                                                    onChange={handleSelectAllScheduled}
                                                    title="Select all scheduled interview candidates on this page"
                                                />
                                            </th>
                                            <th className="py-2 text-center">Candidate</th>
                                            <th className="py-2 text-center">Role</th>
                                            <th className="py-2 text-center">Appearance (10)</th>
                                            <th className="py-2 text-center">Knowledge (10)</th>
                                            <th className="py-2 text-center">Score & Time</th>
                                            <th className="py-2 text-center">Rating (10)</th>
                                            <th className="py-2 text-center">TAT (Days)</th>
                                            <th className="py-2 text-center">Status</th>
                                            <th className="py-2 text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((c) => {
                                            const hasAssessment = c.assessmentResults && c.assessmentResults.length > 0;
                                            const avgScore = hasAssessment
                                                ? Math.round(c.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / c.assessmentResults.length)
                                                : c.technicalScore || 0;

                                            const totalTimeTaken = getCandidateTotalTimeTaken(c);

                                            return (
                                                <tr key={c._id} className={`border-b hover:bg-gray-50 transition-colors ${selectedCandidateIds.includes(c._id) ? "bg-amber-50/40" : ""}`}>
                                                    <td className="px-2 py-2 text-center">
                                                        {isCandidateScheduled(c) ? (
                                                            <input
                                                                type="checkbox"
                                                                className="w-4 h-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500 cursor-pointer accent-amber-600"
                                                                checked={selectedCandidateIds.includes(c._id)}
                                                                onChange={() => handleToggleSelectCandidate(c._id)}
                                                                title="Select for bulk reminder"
                                                            />
                                                        ) : (
                                                            <span className="text-gray-300 text-xs">-</span>
                                                        )}
                                                    </td>
                                                    <td className="px-2 py-2 font-medium text-center">
                                                        <div className="flex flex-col items-center">
                                                            <span className="text-gray-900 whitespace-nowrap font-bold text-sm">{c.firstName} {c.lastName}</span>
                                                            <span className="text-[10px] text-gray-500">{new Date(c.appliedAt).toLocaleDateString()}</span>
                                                            {c.mobile && (
                                                                <span className="text-[9px] text-gray-400 font-mono">{c.mobile}</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        <span className="bg-gray-100 text-gray-600 text-[10px] px-2 py-0.5 rounded uppercase font-bold">
                                                            {c.jobId?.role || "N/A"}
                                                        </span>
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max="10"
                                                            className="w-16 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            value={c.appearanceScore || 0}
                                                            onChange={(e) => handleUpdateScore(c._id, "appearanceScore", e.target.value)}
                                                        />
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max="10"
                                                            className="w-16 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            value={c.workKnowledge || 0}
                                                            onChange={(e) => handleUpdateScore(c._id, "workKnowledge", e.target.value)}
                                                        />
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        <div className="flex flex-col items-center justify-center gap-1">
                                                            <div className="flex items-center gap-2">
                                                                <span className="text-[10px] text-gray-500 font-bold">AVG</span>
                                                                {hasAssessment ? (
                                                                    <span className="w-16 p-1 border rounded text-xs text-center font-bold bg-gray-100 text-gray-800">
                                                                        {avgScore}
                                                                    </span>
                                                                ) : (
                                                                    <input
                                                                        type="number"
                                                                        min="0"
                                                                        max="100"
                                                                        data-gramm="false"
                                                                        spellCheck="false"
                                                                        className="w-16 p-1 border rounded text-xs text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white hover:bg-gray-50 transition-colors"
                                                                        value={c.technicalScore || 0}
                                                                        onChange={(e) => handleUpdateScore(c._id, "technicalScore", e.target.value)}
                                                                    />
                                                                )}
                                                                <button
                                                                    onClick={() => handleOpenAssessmentDetails(c)}
                                                                    disabled={!hasAssessment}
                                                                    className={`p-2 rounded-xl transition-all duration-300 shadow-sm border flex items-center justify-center transform hover:-translate-y-0.5 ${hasAssessment
                                                                            ? 'bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white border-indigo-100 hover:shadow-md cursor-pointer'
                                                                            : 'bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed opacity-50'
                                                                        }`}
                                                                    title={hasAssessment ? "View Answer Sheets" : "No assessment available"}
                                                                >
                                                                    <FiEye size={14} className={`transition-transform ${hasAssessment ? 'group-hover:scale-110' : ''}`} />
                                                                </button>
                                                            </div>
                                                            {hasAssessment && totalTimeTaken !== null ? (
                                                                <div className="flex items-center gap-1 bg-indigo-50 px-2 py-0.5 rounded border border-indigo-100">
                                                                    <FiClock className="text-[10px] text-indigo-500" />
                                                                    <span className="text-[9px] text-indigo-600 font-bold">
                                                                        {formatSecondsToTime(totalTimeTaken)}
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <div className="flex items-center gap-1 bg-gray-50 px-2 py-0.5 rounded border border-gray-100">
                                                                    <FiClock className="text-[10px] text-gray-400" />
                                                                    <span className="text-[9px] text-gray-400 font-bold">
                                                                        N/A
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* ✅ FIX: Rating select with proper default value */}
                                                    <td className="px-2 py-2 text-center">
                                                        <select
                                                            className="p-1 border rounded text-xs font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            value={c.overallRating !== undefined && c.overallRating !== null ? c.overallRating : 0}
                                                            onChange={(e) => handleUpdateScore(c._id, "overallRating", e.target.value)}
                                                        >
                                                            <option value="0">0</option>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="6">6</option>
                                                            <option value="7">7</option>
                                                            <option value="8">8</option>
                                                            <option value="9">9</option>
                                                            <option value="10">10</option>
                                                        </select>
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        {c.appliedAt && c.offerSentAt ? (
                                                            <span className="bg-indigo-50 text-indigo-700 px-2 py-1 rounded-lg text-xs font-bold border border-indigo-100 shadow-sm">
                                                                {Math.ceil(Math.abs(new Date(c.offerSentAt) - new Date(c.appliedAt)) / (1000 * 60 * 60 * 24))} Days
                                                            </span>
                                                        ) : (
                                                            <span className="text-gray-400 text-[10px] font-black italic uppercase tracking-widest">
                                                                {c.status === "Selected" && !c.offerSentAt ? "Pending Offer" : "---"}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        <select
                                                            className={`p-1 border rounded text-[10px] font-bold ${c.status === "Selected" ? "text-green-600 bg-green-50" :
                                                                c.status === "Interview" ? "text-blue-600 bg-blue-50" : "text-gray-600"
                                                                }`
                                                            }

                                                            value={c.status || "Pending"}
                                                            onChange={(e) => handleUpdateScore(c._id, "status", e.target.value)}
                                                        >
                                                            <option value="Pending">PENDING</option>
                                                            <option value="Shortlisted">SHORTLISTED</option>
                                                            <option value="Interview">INTERVIEW</option>
                                                            <option value="Selected">SELECTED</option>
                                                            <option value="Rejected">REJECTED</option>
                                                        </select>
                                                        {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled') && c.candidateInterviewStatus && (
                                                            <div className="mt-1">
                                                                <span className={`text-[8px] font-black uppercase tracking-tighter ${c.candidateInterviewStatus === 'Confirmed' ? 'text-indigo-600 bg-indigo-50 px-1 rounded' : c.candidateInterviewStatus === 'Declined' ? 'text-rose-600 bg-rose-50 px-1 rounded' : 'text-amber-600 bg-amber-50 px-1 rounded'}`}>
                                                                    {c.candidateInterviewStatus === 'Pending' ? 'Awaiting Conf' : `Interview ${c.candidateInterviewStatus}`}
                                                                </span>
                                                                {c.candidateInterviewNote && (
                                                                    <div className="text-[8px] text-gray-400 italic truncate max-w-[80px] mx-auto mt-0.5" title={c.candidateInterviewNote}>
                                                                        "{c.candidateInterviewNote}"
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        <div className="flex justify-center gap-2">
                                                            {c.status === "Interview" && (
                                                                <div className="flex items-center justify-center gap-1.5 flex-wrap">
                                                                    <button
                                                                        onClick={() => handleOpenInviteModal(c)}
                                                                        className="px-2.5 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 flex items-center justify-center gap-1 text-[10px] font-black tracking-wider shadow-md hover:shadow-lg hover:-translate-y-0.5 uppercase"
                                                                        title={(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled' || c.interviewTime) ? "Reschedule Interview" : "Schedule Interview"}
                                                                    >
                                                                        <FiCalendar size={11} />
                                                                        {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled' || c.interviewTime) ? "reschedule" : "schedule"}
                                                                    </button>

                                                                    {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled' || c.interviewTime) && (
                                                                        <button
                                                                            onClick={() => handleOpenReminderModal(c)}
                                                                            className="px-2.5 py-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl hover:from-amber-600 hover:to-orange-600 transition-all duration-300 flex items-center justify-center gap-1 text-[10px] font-black tracking-wider shadow-md hover:shadow-lg hover:-translate-y-0.5 uppercase"
                                                                            title="Send Interview Reminder to Candidate"
                                                                        >
                                                                            <FiBell size={11} />
                                                                            reminder
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {c.status === "Selected" && (
                                                                <div className="flex gap-2">
                                                                    <button
                                                                        onClick={() => handleOpenDetailsModal(c)}
                                                                        className="px-3 py-1.5 bg-gradient-to-r from-gray-500 to-gray-700 text-white rounded-xl hover:from-gray-600 hover:to-gray-800 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                                    >
                                                                        <FiEye size={12} /> VIEW
                                                                    </button>
                                                                    {c.resume && (
                                                                        <button
                                                                            onClick={() => {
                                                                                const link = document.createElement('a');
                                                                                link.href = formatDocUrl(c.resume);
                                                                                link.download = `${c.firstName}_Resume.pdf`;
                                                                                document.body.appendChild(link);
                                                                                link.click();
                                                                                document.body.removeChild(link);
                                                                            }}
                                                                            className="px-3 py-1.5 bg-gradient-to-r from-blue-400 to-indigo-500 text-white rounded-xl hover:from-blue-500 hover:to-indigo-600 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                                            title="Download Resume"
                                                                        >
                                                                            <FiDownload size={12} /> RESUME
                                                                        </button>
                                                                    )}
                                                                    <button
                                                                        onClick={() => handleOpenOfferModal(c)}
                                                                        className="px-3 py-1.5 bg-gradient-to-r from-purple-500 to-fuchsia-600 text-white rounded-xl hover:from-purple-600 hover:to-fuchsia-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                                    >
                                                                        OFFER
                                                                    </button>

                                                                    <button
                                                                        onClick={() => handleOpenDocsModal(c)}
                                                                        className={`px-3 py-1.5 text-white rounded-xl transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5 ${c.docReviewStatus === "Accepted"
                                                                            ? "bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600"
                                                                            : c.docReviewStatus === "Pending"
                                                                                ? "bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600"
                                                                                : "bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900"
                                                                            }`
                                                                        }

                                                                    >
                                                                        DOCS
                                                                    </button>

                                                                    <button
                                                                        onClick={() => handleOpenPackageModal(c)}
                                                                        className="px-3 py-1.5 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-xl hover:from-indigo-600 hover:to-blue-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                                    >
                                                                        PACKAGE
                                                                    </button>

                                                                    <button
                                                                        onClick={() => handleOpenHistoryModal(c)}
                                                                        className="px-3 py-1.5 bg-gradient-to-r from-slate-500 to-slate-700 text-white rounded-xl hover:from-slate-600 hover:to-slate-800 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                                        title="Document History"
                                                                    >
                                                                        <FiClock size={12} /> HISTORY
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Mobile Card View */}
                            <div className="md:hidden space-y-4 p-2">
                                {currentItems.map((c) => {
                                    const hasAssessment = c.assessmentResults && c.assessmentResults.length > 0;
                                    const avgScore = hasAssessment
                                        ? Math.round(c.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / c.assessmentResults.length)
                                        : c.technicalScore || 0;

                                    const totalTimeTaken = getCandidateTotalTimeTaken(c);

                                    return (
                                        <div key={c._id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-200">
                                            {/* Card Header */}
                                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100">
                                                <div className="flex justify-between items-start">
                                                    <div className="flex items-start gap-2.5 flex-1 min-w-0">
                                                        {isCandidateScheduled(c) && (
                                                            <input
                                                                type="checkbox"
                                                                className="mt-0.5 w-4 h-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500 cursor-pointer accent-amber-600 shrink-0"
                                                                checked={selectedCandidateIds.includes(c._id)}
                                                                onChange={() => handleToggleSelectCandidate(c._id)}
                                                                title="Select for bulk reminder"
                                                            />
                                                        )}
                                                        <div className="flex-1 min-w-0">
                                                            <h3 className="font-bold text-gray-900 text-sm truncate">
                                                                {c.firstName} {c.lastName}
                                                            </h3>
                                                        <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                                                            <span className="text-[10px] text-gray-500">
                                                                {new Date(c.appliedAt).toLocaleDateString()}
                                                            </span>
                                                            <span className="bg-gray-100 text-gray-600 text-[9px] px-1.5 py-0.5 rounded uppercase font-bold truncate max-w-[120px]">
                                                                {c.jobId?.role || "N/A"}
                                                            </span>
                                                            {c.mobile && (
                                                                <span className="text-[9px] text-gray-400 font-mono">
                                                                    📱 {c.mobile}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div className="flex items-center gap-1 ml-2">
                                                        <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase ${c.status === "Selected" ? "bg-green-100 text-green-700" :
                                                                c.status === "Interview" ? "bg-blue-100 text-blue-700" :
                                                                    c.status === "Shortlisted" ? "bg-yellow-100 text-yellow-700" :
                                                                        "bg-gray-100 text-gray-600"
                                                            }`}>
                                                            {c.status || "Pending"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Card Body */}
                                            <div className="p-4 space-y-3">
                                                {/* Scores Grid */}
                                                <div className="grid grid-cols-2 gap-2">
                                                    <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
                                                        <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Appearance</p>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max="10"
                                                            className="w-full mt-1 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            value={c.appearanceScore || 0}
                                                            onChange={(e) => handleUpdateScore(c._id, "appearanceScore", e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
                                                        <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Knowledge</p>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max="10"
                                                            className="w-full mt-1 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            value={c.workKnowledge || 0}
                                                            onChange={(e) => handleUpdateScore(c._id, "workKnowledge", e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
                                                        <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Avg Score</p>
                                                        {hasAssessment ? (
                                                            <span className="w-full mt-1 p-1 border rounded text-xs text-center font-bold bg-gray-100 text-gray-800 block">
                                                                {avgScore}
                                                            </span>
                                                        ) : (
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                                className="w-full mt-1 p-1 border rounded text-xs text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                value={c.technicalScore || 0}
                                                                onChange={(e) => handleUpdateScore(c._id, "technicalScore", e.target.value)}
                                                            />
                                                        )}
                                                        {hasAssessment && totalTimeTaken !== null ? (
                                                            <div className="flex items-center justify-center gap-1 mt-1">
                                                                <FiClock className="text-[8px] text-indigo-500" />
                                                                <span className="text-[8px] text-indigo-600 font-bold">
                                                                    {formatSecondsToTime(totalTimeTaken)}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className="flex items-center justify-center gap-1 mt-1">
                                                                <FiClock className="text-[8px] text-gray-400" />
                                                                <span className="text-[8px] text-gray-400 font-bold">
                                                                    N/A
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="bg-gray-50 rounded-lg p-2 text-center border border-gray-100">
                                                        <p className="text-[7px] text-gray-500 uppercase font-bold tracking-wider">Rating</p>
                                                        <select
                                                            className="w-full mt-1 p-1 border rounded text-xs font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                                                            value={c.overallRating !== undefined && c.overallRating !== null ? c.overallRating : 0}
                                                            onChange={(e) => handleUpdateScore(c._id, "overallRating", e.target.value)}
                                                        >
                                                            <option value="0">0</option>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="6">6</option>
                                                            <option value="7">7</option>
                                                            <option value="8">8</option>
                                                            <option value="9">9</option>
                                                            <option value="10">10</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* TAT Info */}
                                                {c.appliedAt && c.offerSentAt && (
                                                    <div className="text-center bg-indigo-50 rounded-lg p-1.5 border border-indigo-100">
                                                        <span className="text-[10px] font-bold text-indigo-700">
                                                            TAT: {Math.ceil(Math.abs(new Date(c.offerSentAt) - new Date(c.appliedAt)) / (1000 * 60 * 60 * 24))} Days
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Status Select and Actions */}
                                                <div className="flex flex-wrap items-center gap-2 pt-2 border-t border-gray-100">
                                                    <div className="flex-1 min-w-[120px]">
                                                        <select
                                                            className={`w-full p-1.5 border rounded-lg text-[10px] font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 ${c.status === "Selected" ? "text-green-600 bg-green-50 border-green-200" :
                                                                    c.status === "Interview" ? "text-blue-600 bg-blue-50 border-blue-200" :
                                                                        "text-gray-600 bg-gray-50 border-gray-200"
                                                                }`}
                                                            value={c.status || "Pending"}
                                                            onChange={(e) => handleUpdateScore(c._id, "status", e.target.value)}
                                                        >
                                                            <option value="Pending">PENDING</option>
                                                            <option value="Shortlisted">SHORTLISTED</option>
                                                            <option value="Interview">INTERVIEW</option>
                                                            <option value="Selected">SELECTED</option>
                                                            <option value="Rejected">REJECTED</option>
                                                        </select>
                                                    </div>

                                                    <div className="flex flex-wrap gap-1.5">
                                                        <button
                                                            onClick={() => handleOpenAssessmentDetails(c)}
                                                            disabled={!hasAssessment}
                                                            className={`p-2 rounded-lg border ${hasAssessment
                                                                    ? 'bg-indigo-50 text-indigo-600 border-indigo-200 hover:bg-indigo-600 hover:text-white hover:border-indigo-600'
                                                                    : 'bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed opacity-50'
                                                                } transition-all duration-200`}
                                                            title={hasAssessment ? "View Answer Sheets" : "No assessment available"}
                                                        >
                                                            <FiEye size={14} />
                                                        </button>
                                                        {hasAssessment && totalTimeTaken !== null ? (
                                                            <div className="flex items-center gap-1 px-2 py-1 bg-indigo-50 rounded-lg border border-indigo-200">
                                                                <FiClock size={12} className="text-indigo-600" />
                                                                <span className="text-[9px] font-bold text-indigo-600">
                                                                    {formatSecondsToTime(totalTimeTaken)}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className="flex items-center gap-1 px-2 py-1 bg-gray-50 rounded-lg border border-gray-200">
                                                                <FiClock size={12} className="text-gray-400" />
                                                                <span className="text-[9px] font-bold text-gray-400">
                                                                    N/A
                                                                </span>
                                                            </div>
                                                        )}

                                                        {c.status === "Interview" && (
                                                            <div className="flex items-center gap-1.5 flex-wrap">
                                                                <button
                                                                    onClick={() => handleOpenInviteModal(c)}
                                                                    className="px-2.5 py-1.5 bg-blue-600 text-white rounded-lg text-[10px] font-bold hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow flex items-center gap-1"
                                                                    title={(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled' || c.interviewTime) ? "Reschedule Interview" : "Schedule Interview"}
                                                                >
                                                                    <FiCalendar size={11} />
                                                                    {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled' || c.interviewTime) ? "RESCHEDULE" : "SCHEDULE"}
                                                                </button>
                                                                {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled' || c.interviewTime) && (
                                                                    <button
                                                                        onClick={() => handleOpenReminderModal(c)}
                                                                        className="px-2.5 py-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg text-[10px] font-bold hover:from-amber-600 hover:to-orange-600 transition-all duration-200 shadow-sm hover:shadow flex items-center gap-1"
                                                                        title="Send Interview Reminder"
                                                                    >
                                                                        <FiBell size={11} />
                                                                        REMINDER
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}

                                                        {c.status === "Selected" && (
                                                            <>
                                                                <button
                                                                    onClick={() => handleOpenDetailsModal(c)}
                                                                    className="p-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-200"
                                                                    title="View Details"
                                                                >
                                                                    <FiEye size={14} />
                                                                </button>
                                                                {c.resume && (
                                                                    <button
                                                                        onClick={() => {
                                                                            const link = document.createElement('a');
                                                                            link.href = formatDocUrl(c.resume);
                                                                            link.download = `${c.firstName}_Resume.pdf`;
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                            document.body.removeChild(link);
                                                                        }}
                                                                        className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200"
                                                                        title="Download Resume"
                                                                    >
                                                                        <FiDownload size={14} />
                                                                    </button>
                                                                )}
                                                                {c.resume && (
                                                                    <button
                                                                        onClick={() => handleOpenOfferModal(c)}
                                                                        className="p-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all duration-200"
                                                                        title="Send Offer"
                                                                    >
                                                                        <FiFileText size={14} />
                                                                    </button>
                                                                )}
                                                                <button
                                                                    onClick={() => handleOpenDocsModal(c)}
                                                                    className={`p-2 text-white rounded-lg transition-all duration-200 ${c.docReviewStatus === "Accepted"
                                                                            ? "bg-emerald-500 hover:bg-emerald-600"
                                                                            : c.docReviewStatus === "Pending"
                                                                                ? "bg-amber-500 hover:bg-amber-600"
                                                                                : "bg-slate-700 hover:bg-slate-800"
                                                                        }`}
                                                                    title="Documents"
                                                                >
                                                                    <FiFileText size={14} />
                                                                </button>
                                                                <button
                                                                    onClick={() => handleOpenPackageModal(c)}
                                                                    className="p-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all duration-200"
                                                                    title="Package Details"
                                                                >
                                                                    <FiBriefcase size={14} />
                                                                </button>
                                                                <button
                                                                    onClick={() => handleOpenHistoryModal(c)}
                                                                    className="p-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-all duration-200"
                                                                    title="Document History"
                                                                >
                                                                    <FiClock size={14} />
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>

                                                {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled') && c.candidateInterviewStatus && (
                                                    <div className="mt-1 text-center">
                                                        <span className={`text-[8px] font-bold uppercase px-2 py-0.5 rounded ${c.candidateInterviewStatus === 'Confirmed' ? 'bg-indigo-100 text-indigo-700' :
                                                                c.candidateInterviewStatus === 'Declined' ? 'bg-rose-100 text-rose-700' :
                                                                    'bg-amber-100 text-amber-700'
                                                            }`}>
                                                            {c.candidateInterviewStatus === 'Pending' ? 'Awaiting Confirmation' : `Interview ${c.candidateInterviewStatus}`}
                                                        </span>
                                                        {c.candidateInterviewNote && (
                                                            <div className="text-[8px] text-gray-400 italic mt-0.5 truncate" title={c.candidateInterviewNote}>
                                                                "{c.candidateInterviewNote}"
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Pagination */}
                            {filteredCandidates.length > 0 && (
                                <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 border-t border-gray-200/50 bg-gray-50/30">
                                    <div className="flex flex-wrap items-center gap-3">
                                        <div className="flex items-center gap-2 text-xs text-gray-500">
                                            <span>Show</span>
                                            <select
                                                value={pagination.limit}
                                                onChange={(e) => {
                                                    const newLimit = Number(e.target.value);
                                                    handleItemsPerPageChange(newLimit);
                                                }}
                                                className="p-1 border border-gray-300 rounded-md bg-white text-gray-700 focus:outline-none"
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>
                                            <span>entries</span>
                                        </div>
                                        <div className="text-xs text-gray-500 font-medium">
                                            Showing <strong className="text-gray-800">{indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredCandidates.length)}</strong> of{" "}
                                            <strong className="text-gray-800">{filteredCandidates.length}</strong> candidates
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-1.5">
                                        <button
                                            onClick={handlePrevPage}
                                            disabled={pagination.currentPage === 1}
                                            className={`px-2.5 py-1 text-xs font-semibold border rounded-lg transition-all ${pagination.currentPage === 1
                                                    ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
                                                    : "text-gray-700 bg-white hover:bg-gray-55 border-gray-300 shadow-sm"
                                                }`}
                                        >
                                            Prev
                                        </button>

                                        {getPageNumbers().map((page, index) => (
                                            <button
                                                key={index}
                                                onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
                                                disabled={page === "..."}
                                                className={`px-3 py-1 text-xs font-semibold border rounded-lg transition-all min-w-[32px] ${page === "..."
                                                        ? "text-gray-400 bg-transparent border-transparent cursor-default"
                                                        : pagination.currentPage === page
                                                            ? "text-white bg-blue-600 border-blue-600 shadow-sm"
                                                            : "text-gray-700 bg-white hover:bg-gray-55 border-gray-300"
                                                    }`}
                                            >
                                                {page}
                                            </button>
                                        ))}

                                        <button
                                            onClick={handleNextPage}
                                            disabled={pagination.currentPage === pagination.totalPages}
                                            className={`px-2.5 py-1 text-xs font-semibold border rounded-lg transition-all ${pagination.currentPage === pagination.totalPages
                                                    ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
                                                    : "text-gray-700 bg-white hover:bg-gray-55 border-gray-300 shadow-sm"
                                                }`}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="emp-dash__card-body py-12 text-center text-gray-500">
                            <div className="mb-3 text-4xl text-gray-300">👥</div>
                            <p className="mb-1 text-sm font-semibold text-gray-800">No candidates found</p>
                            <p className="text-xs text-gray-500 mb-5 max-w-xs mx-auto">There are no candidates matching the selected search query or filters.</p>
                            {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter || statusFilter) && (
                                <button
                                    onClick={resetFilters}
                                    className="px-4 py-2 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-55 transition-all shadow-sm"
                                >
                                    Clear Filters
                                </button>
                            )}
                        </div>
                    )}
                </div>

                {/* ========================================= */}
                {/* INVITE MODAL - UPDATED WITH ADDRESS */}
                {/* ========================================= */}
                {isInviteModalOpen && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                        <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
                            <button
                                onClick={() => setIsInviteModalOpen(false)}
                                className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                            >
                                <FiX className="text-lg" />
                            </button>
                            <div className="px-8 pt-8 pb-4">
                                <h2 className="text-xl text-gray-800">Send Interview Invite</h2>
                                <p className="text-[10px] font-bold uppercase tracking-widest mt-1">Schedule interview for candidate</p>
                            </div>
                            <div className="p-8 pt-4">
                                <p className="text-sm text-gray-600 mb-4">
                                    Candidate: <span className="font-semibold text-gray-800">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
                                </p>
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                                        <input
                                            type="text"
                                            className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
                                            value={inviteForm.subject}
                                            onChange={(e) => setInviteForm({ ...inviteForm, subject: e.target.value })}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Interview Time & Date</label>
                                        <input
                                            type="datetime-local"
                                            className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
                                            value={inviteForm.time}
                                            onChange={(e) => setInviteForm({ ...inviteForm, time: e.target.value })}
                                            min={new Date().toISOString().slice(0, 16)}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Interview Mode</label>
                                        <select
                                            className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 font-bold text-sm"
                                            value={inviteForm.interviewMode}
                                            onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                const selectedLocation = locations.find(loc => loc.fullAddress === selectedValue);

                                                if (selectedLocation) {
                                                    setInviteForm({
                                                        ...inviteForm,
                                                        interviewMode: "In-Person",
                                                        interviewAddress: selectedLocation.fullAddress
                                                    });
                                                } else {
                                                    setInviteForm({
                                                        ...inviteForm,
                                                        interviewMode: selectedValue,
                                                        interviewAddress: ""
                                                    });
                                                }
                                            }}
                                        >
                                            <option value="Online">🌐 Online (Google Meet / Zoom)</option>
                                            <option value="Virtual">💻 Virtual</option>
                                            <option value="In-Person">🏢 In-Person (Office)</option>
                                            {locations.map(loc => (
                                                <option key={loc._id} value={loc.fullAddress}>
                                                    📍 {loc.name} - {loc.fullAddress}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {inviteForm.interviewMode === "In-Person" && inviteForm.interviewAddress && (
                                        <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                                            <p className="text-[10px] font-bold text-blue-700 uppercase tracking-widest flex items-center gap-2">
                                                <FiMapPin size={12} /> Selected Address:
                                            </p>
                                            <p className="text-xs font-semibold text-gray-700 mt-1">{inviteForm.interviewAddress}</p>
                                        </div>
                                    )}
                                </div>
                                <div className="flex justify-end gap-3 mt-6">
                                    <button
                                        className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                                        onClick={() => setIsInviteModalOpen(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 shadow-lg"
                                        onClick={handleSendInvite}
                                    >
                                        Send Invitation
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ========================================= */}
                {/* INTERVIEW REMINDER MODAL */}
                {/* ========================================= */}
                {isReminderModalOpen && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                        <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
                            <button
                                onClick={() => setIsReminderModalOpen(false)}
                                className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                            >
                                <FiX className="text-lg" />
                            </button>
                            <div className="px-8 pt-8 pb-4 border-b border-gray-100 bg-gradient-to-r from-amber-50 to-orange-50">
                                <div className="flex items-center gap-2.5">
                                    <div className="w-9 h-9 rounded-xl bg-amber-500 text-white flex items-center justify-center shadow-md">
                                        <FiBell className="text-lg" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold text-gray-800">Send Interview Reminder</h2>
                                        <p className="text-[10px] font-bold uppercase tracking-widest text-amber-700 mt-0.5">Notify candidate about upcoming interview</p>
                                    </div>
                                </div>
                            </div>
                            <div className="p-8 pt-5 space-y-4 max-h-[75vh] overflow-y-auto">
                                {/* Candidate Info Card */}
                                <div className="p-3 bg-gray-50 rounded-xl border border-gray-200 flex items-center justify-between">
                                    <div>
                                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block">Candidate</span>
                                        <p className="text-sm font-bold text-gray-800">
                                            {selectedCandidate?.firstName} {selectedCandidate?.lastName}
                                        </p>
                                        <p className="text-xs text-gray-500">{selectedCandidate?.email}</p>
                                    </div>
                                    <div className="text-right">
                                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block">Role</span>
                                        <span className="inline-block px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs font-semibold">
                                            {selectedCandidate?.jobId?.role || "Candidate"}
                                        </span>
                                    </div>
                                </div>

                                {/* Scheduled Details Summary */}
                                <div className="p-3 bg-amber-50/70 rounded-xl border border-amber-200 space-y-2 text-xs">
                                    <div className="flex items-center justify-between">
                                        <span className="text-gray-600 font-medium flex items-center gap-1.5">
                                            <FiCalendar size={13} className="text-amber-600" /> Date & Time:
                                        </span>
                                        <span className="font-bold text-gray-800">
                                            {reminderForm.time ? new Date(reminderForm.time).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : "Not Set"}
                                        </span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <span className="text-gray-600 font-medium flex items-center gap-1.5">
                                            <FiClock size={13} className="text-amber-600" /> Mode:
                                        </span>
                                        <span className="font-bold text-gray-800">{reminderForm.interviewMode || "Online"}</span>
                                    </div>
                                    {reminderForm.interviewAddress && (
                                        <div className="flex items-start justify-between gap-2 pt-1 border-t border-amber-200/60">
                                            <span className="text-gray-600 font-medium flex items-center gap-1.5 shrink-0">
                                                <FiMapPin size={13} className="text-amber-600" /> Address:
                                            </span>
                                            <span className="font-semibold text-gray-700 text-right">{reminderForm.interviewAddress}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Editable Subject */}
                                <div>
                                    <label className="block text-xs font-bold uppercase text-gray-600 mb-1 tracking-wider">
                                        Email Subject
                                    </label>
                                    <input
                                        type="text"
                                        className="w-full p-2.5 text-sm border rounded-xl focus:ring-2 focus:ring-amber-500 focus:outline-none"
                                        value={reminderForm.subject}
                                        onChange={(e) => setReminderForm({ ...reminderForm, subject: e.target.value })}
                                        placeholder="Interview Reminder Subject"
                                    />
                                </div>

                                {/* Editable Date / Time */}
                                <div>
                                    <label className="block text-xs font-bold uppercase text-gray-600 mb-1 tracking-wider">
                                        Interview Date & Time
                                    </label>
                                    <input
                                        type="datetime-local"
                                        className="w-full p-2.5 text-sm border rounded-xl focus:ring-2 focus:ring-amber-500 focus:outline-none"
                                        value={reminderForm.time}
                                        onChange={(e) => setReminderForm({ ...reminderForm, time: e.target.value })}
                                    />
                                </div>

                                {/* Custom Note to Candidate */}
                                <div>
                                    <label className="block text-xs font-bold uppercase text-gray-600 mb-1 tracking-wider">
                                        Custom Note to Candidate (Optional)
                                    </label>
                                    <textarea
                                        rows={3}
                                        className="w-full p-2.5 text-sm border rounded-xl focus:ring-2 focus:ring-amber-500 focus:outline-none"
                                        value={reminderForm.note}
                                        onChange={(e) => setReminderForm({ ...reminderForm, note: e.target.value })}
                                        placeholder="Add instructions, meeting link details, or notes..."
                                    />
                                </div>

                                <div className="flex justify-end gap-3 pt-3 border-t border-gray-100">
                                    <button
                                        type="button"
                                        className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-xl transition-all"
                                        onClick={() => setIsReminderModalOpen(false)}
                                        disabled={reminderSending}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="px-5 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold text-sm rounded-xl hover:from-amber-600 hover:to-orange-600 shadow-md hover:shadow-lg transition-all flex items-center gap-2 disabled:opacity-50"
                                        onClick={handleSendReminder}
                                        disabled={reminderSending}
                                    >
                                        {reminderSending ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                Sending...
                                            </>
                                        ) : (
                                            <>
                                                <FiSend size={14} /> Send Reminder
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ========================================= */}
                {/* BULK INTERVIEW REMINDER MODAL */}
                {/* ========================================= */}
                {isBulkReminderModalOpen && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                        <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100 flex flex-col max-h-[90vh]">
                            <button
                                onClick={() => setIsBulkReminderModalOpen(false)}
                                className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all z-10"
                            >
                                <FiX className="text-lg" />
                            </button>
                            <div className="px-8 pt-8 pb-4 border-b border-gray-100 bg-gradient-to-r from-amber-50 to-orange-50 shrink-0">
                                <div className="flex items-center gap-2.5">
                                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 text-white flex items-center justify-center shadow-md">
                                        <FiUsers className="text-xl" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold text-gray-800">Bulk Interview Reminder</h2>
                                        <p className="text-[10px] font-bold uppercase tracking-widest text-amber-700 mt-0.5">
                                            Send interview reminders to multiple candidates at once
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="p-8 pt-5 space-y-4 overflow-y-auto flex-1">
                                {/* Candidates Selection List Header */}
                                <div>
                                    <div className="flex items-center justify-between mb-2">
                                        <div className="flex items-center gap-2">
                                            <label className="text-xs font-bold uppercase text-gray-600 tracking-wider">
                                                Select Candidates
                                            </label>
                                            <span className="px-2 py-0.5 bg-amber-100 text-amber-800 rounded-full text-[10px] font-bold">
                                                {selectedCandidateIds.length} selected
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const allIds = filteredCandidates.filter(isCandidateScheduled).map((c) => c._id);
                                                    setSelectedCandidateIds(allIds);
                                                }}
                                                className="text-[11px] font-semibold text-amber-700 hover:text-amber-800 hover:underline"
                                            >
                                                Select All
                                            </button>
                                            <span className="text-gray-300">|</span>
                                            <button
                                                type="button"
                                                onClick={() => setSelectedCandidateIds([])}
                                                className="text-[11px] font-semibold text-gray-500 hover:text-gray-700 hover:underline"
                                            >
                                                Deselect All
                                            </button>
                                        </div>
                                    </div>

                                    {/* Candidates list */}
                                    <div className="border border-gray-200 rounded-xl max-h-48 overflow-y-auto divide-y divide-gray-100 bg-gray-55/40">
                                        {filteredCandidates.filter(isCandidateScheduled).length === 0 ? (
                                            <div className="p-4 text-center text-gray-400 text-xs font-medium">
                                                No candidates with scheduled interviews found.
                                            </div>
                                        ) : (
                                            filteredCandidates.filter(isCandidateScheduled).map((c) => {
                                                const isChecked = selectedCandidateIds.includes(c._id);
                                                return (
                                                    <div
                                                        key={c._id}
                                                        onClick={() => handleToggleSelectCandidate(c._id)}
                                                        className={`p-3 flex items-center justify-between gap-3 cursor-pointer transition-colors ${
                                                            isChecked ? "bg-amber-50/70" : "hover:bg-gray-50"
                                                        }`}
                                                    >
                                                        <div className="flex items-center gap-2.5 min-w-0">
                                                            <input
                                                                type="checkbox"
                                                                checked={isChecked}
                                                                onChange={() => {}} // handled by parent onClick
                                                                className="w-4 h-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500 pointer-events-none accent-amber-600 shrink-0"
                                                            />
                                                            <div className="min-w-0">
                                                                <p className="text-xs font-bold text-gray-800 truncate">
                                                                    {c.firstName} {c.lastName}
                                                                </p>
                                                                <p className="text-[10px] text-gray-500 truncate">{c.email}</p>
                                                            </div>
                                                        </div>

                                                        <div className="text-right shrink-0">
                                                            <span className="inline-block px-1.5 py-0.5 bg-blue-50 text-blue-700 rounded text-[9px] font-bold uppercase mb-0.5">
                                                                {c.jobId?.role || "Interview"}
                                                            </span>
                                                            <div className="text-[10px] font-semibold text-amber-700 flex items-center gap-1 justify-end">
                                                                <FiCalendar size={10} />
                                                                {c.interviewTime
                                                                    ? new Date(c.interviewTime).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })
                                                                    : "Scheduled"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>

                                {/* Subject */}
                                <div>
                                    <label className="block text-xs font-bold uppercase text-gray-600 mb-1 tracking-wider">
                                        Email Subject
                                    </label>
                                    <input
                                        type="text"
                                        className="w-full p-2.5 text-sm border rounded-xl focus:ring-2 focus:ring-amber-500 focus:outline-none"
                                        value={bulkReminderForm.subject}
                                        onChange={(e) => setBulkReminderForm({ ...bulkReminderForm, subject: e.target.value })}
                                        placeholder="Interview Reminder Subject"
                                    />
                                </div>

                                {/* Note / Message */}
                                <div>
                                    <label className="block text-xs font-bold uppercase text-gray-600 mb-1 tracking-wider">
                                        Custom Message to All Candidates
                                    </label>
                                    <textarea
                                        rows={3}
                                        className="w-full p-2.5 text-sm border rounded-xl focus:ring-2 focus:ring-amber-500 focus:outline-none"
                                        value={bulkReminderForm.note}
                                        onChange={(e) => setBulkReminderForm({ ...bulkReminderForm, note: e.target.value })}
                                        placeholder="Add instructions, link details, or reminders..."
                                    />
                                </div>
                            </div>

                            <div className="flex items-center justify-between p-4 px-8 border-t border-gray-100 bg-gray-50/50 shrink-0">
                                <span className="text-xs text-gray-500">
                                    Will notify <strong>{selectedCandidateIds.length}</strong> candidate(s) via email &amp; push notification.
                                </span>
                                <div className="flex items-center gap-3">
                                    <button
                                        type="button"
                                        className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-xl transition-all"
                                        onClick={() => setIsBulkReminderModalOpen(false)}
                                        disabled={bulkReminderSending}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="px-5 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold text-sm rounded-xl hover:from-amber-600 hover:to-orange-600 shadow-md hover:shadow-lg transition-all flex items-center gap-2 disabled:opacity-50"
                                        onClick={handleSendBulkReminder}
                                        disabled={bulkReminderSending || selectedCandidateIds.length === 0}
                                    >
                                        {bulkReminderSending ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                Sending Reminders...
                                            </>
                                        ) : (
                                            <>
                                                <FiSend size={14} /> Send Reminders ({selectedCandidateIds.length})
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Document Management Modal */}
                {isDocsModalOpen && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                        <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
                            <button
                                onClick={() => setIsDocsModalOpen(false)}
                                className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                            >
                                <FiX className="text-lg" />
                            </button>
                            <div className="px-8 pt-8 pb-4">
                                <h2 className="text-xl text-gray-800">Document Management</h2>
                                <p className="text-[10px] font-bold uppercase tracking-widest mt-1">Review Status: {selectedCandidate?.docReviewStatus}</p>
                            </div>
                            <div className="p-8 pt-4 space-y-6 max-h-[70vh] overflow-y-auto">
                                {/* Step 1: Send Agreements */}
                                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                    <h3 className="text-sm font-black uppercase text-gray-700 mb-3 tracking-wider">Step 1: Agreements for Candidate</h3>
                                    <textarea
                                        className="w-full p-3 border rounded-md text-sm min-h-[150px] focus:ring-2 focus:ring-indigo-500"
                                        placeholder="Enter agreement terms or instructions..."
                                        value={docsForm.agreementsContent}
                                        onChange={(e) => setDocsForm({ ...docsForm, agreementsContent: e.target.value })}
                                    />
                                    <div className="mt-3">
                                        <label className="block text-xs font-bold text-gray-500 mb-1 uppercase">Attach Agreement Check (PDF/Doc)</label>
                                        <input
                                            type="file"
                                            className="w-full text-xs text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                                            onChange={(e) => setDocsFile(e.target.files[0])}
                                        />
                                    </div>
                                    <button
                                        onClick={handleSendAgreements}
                                        className="mt-3 px-6 py-2 bg-indigo-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-indigo-700"
                                    >
                                        Send / Update Agreements
                                    </button>
                                </div>

                                {/* Step 2: Review Candidate Upload */}
                                {selectedCandidate?.candidateAgreementsUpload && (
                                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                        <h3 className="text-sm font-black uppercase text-blue-800 mb-3 tracking-wider">Step 2: Review Uploaded Document</h3>
                                        <div className="flex items-center justify-between bg-white p-3 rounded border border-blue-100 mb-4">
                                            <div className="flex items-center gap-2">
                                                <span className="text-xs font-bold text-gray-700">Signed_Agreement.pdf</span>
                                            </div>
                                        </div>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => window.open(formatDocUrl(selectedCandidate.candidateAgreementsUpload), "_blank")}
                                                className="flex-1 px-6 py-2 bg-indigo-600 text-white rounded-lg text-xs font-black uppercase tracking-widest shadow-lg hover:bg-indigo-700 transition-all active:scale-95 flex items-center justify-center gap-2"
                                            >
                                                <FiEye size={14} /> View
                                            </button>
                                            <button
                                                onClick={() => {
                                                    const link = document.createElement('a');
                                                    link.href = formatDocUrl(selectedCandidate.candidateAgreementsUpload);
                                                    link.download = `Signed_Agreement_${selectedCandidate.firstName}.pdf`;
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link);
                                                }}
                                                className="flex-1 px-6 py-2 bg-emerald-600 text-white rounded-lg text-xs font-black uppercase tracking-widest shadow-lg hover:bg-emerald-700 transition-all active:scale-95 flex items-center justify-center gap-2"
                                            >
                                                <FiDownload size={14} /> Download
                                            </button>
                                        </div>
                                        <div className="flex gap-2 mt-4">
                                            <button
                                                onClick={() => handleReviewDocs("Accepted")}
                                                className="flex-1 py-2 bg-green-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-green-700 shadow-md"
                                            >
                                                Accept Documents
                                            </button>
                                            <button
                                                onClick={() => handleReviewDocs("Rejected")}
                                                className="flex-1 py-2 bg-red-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-red-700 shadow-md"
                                            >
                                                Reject & Resubmit
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {!selectedCandidate?.candidateAgreementsUpload && (
                                    <div className="text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
                                        <p className="text-xs font-bold text-gray-400 uppercase">Awaiting candidate upload...</p>
                                    </div>
                                )}

                                {/* Step 3: Personal Documents */}
                                <div className="bg-white p-4 rounded-lg border border-gray-200">
                                    <h3 className="text-sm font-black uppercase text-gray-700 mb-4 tracking-wider flex items-center gap-2">
                                        <FiFileText className="text-blue-500" /> Step 3: Personal Documents & Details
                                    </h3>

                                    {personalDocsLoading ? (
                                        <div className="flex items-center justify-center p-8">
                                            <div className="w-6 h-6 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                                            <p className="ml-3 text-xs font-bold text-gray-400 uppercase tracking-widest">Fetching Docs...</p>
                                        </div>
                                    ) : personalDocs ? (
                                        <div className="space-y-6">
                                            {/* Document Grid */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                {[
                                                    { title: "Aadhar Card", type: "aadharCard" },
                                                    { title: "PAN Card", type: "panCard" },
                                                    { title: "10th Certificate", type: "tenthCertificate" },
                                                    { title: "12th Certificate", type: "twelfthCertificate" },
                                                    { title: "Graduation", type: "graduationCertificate" },
                                                    { title: "Passport Photo", type: "passportPhoto" },
                                                    { title: "Exp. Letters", type: "experienceLetters" }
                                                ].map((cat) => {
                                                    const doc = personalDocs.documents?.[cat.type];
                                                    const isUploaded = !!doc?.url;
                                                    return (
                                                        <div key={cat.type} className={`p-3 rounded-xl border flex items-center justify-between transition-all ${isUploaded ? "bg-emerald-50/30 border-emerald-100" : "bg-gray-50 border-gray-100"}`}>
                                                            <div className="flex items-center gap-2">
                                                                <div className={`p-2 rounded-lg ${isUploaded ? "bg-emerald-100 text-emerald-600" : "bg-gray-100 text-gray-400"}`}>
                                                                    <FiFileText size={14} />
                                                                </div>
                                                                <div>
                                                                    <p className="text-[10px] font-bold text-gray-800 uppercase tracking-tight">{cat.title}</p>
                                                                    {isUploaded ? (
                                                                        <p className="text-[8px] font-bold text-emerald-600 uppercase tracking-widest flex items-center gap-1">
                                                                            <FiCheckCircle size={8} /> Uploaded
                                                                        </p>
                                                                    ) : (
                                                                        <p className="text-[8px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1">
                                                                            <FiAlertTriangle size={8} /> Missing
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {isUploaded && (
                                                                <div className="flex gap-1">
                                                                    <button
                                                                        onClick={() => window.open(formatDocUrl(doc.url), '_blank')}
                                                                        className="px-3 py-1 bg-white border border-slate-200 text-slate-700 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-slate-600 hover:text-white transition-all shadow-sm"
                                                                        title="View"
                                                                    >
                                                                        <FiEye size={10} />
                                                                    </button>
                                                                    <button
                                                                        onClick={() => {
                                                                            const link = document.createElement('a');
                                                                            link.href = formatDocUrl(doc.url);
                                                                            link.download = `${cat.title}_${selectedCandidate.firstName}.pdf`;
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                            document.body.removeChild(link);
                                                                        }}
                                                                        className="px-3 py-1 bg-white border border-emerald-200 text-emerald-700 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-emerald-600 hover:text-white transition-all shadow-sm"
                                                                        title="Download"
                                                                    >
                                                                        <FiDownload size={10} />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* Bank Details */}
                                            <div className="p-4 bg-blue-50/50 rounded-xl border border-blue-100">
                                                <h4 className="text-[10px] font-black uppercase text-blue-700 mb-3 tracking-widest flex items-center gap-2">
                                                    <FiAward /> Bank Details
                                                </h4>
                                                {personalDocs.documents?.bankDetails?.bankName ? (
                                                    <div className="grid grid-cols-3 gap-4">
                                                        <div>
                                                            <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Bank Name</p>
                                                            <p className="text-xs font-bold text-gray-800 uppercase">{personalDocs.documents.bankDetails.bankName}</p>
                                                        </div>
                                                        <div>
                                                            <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">A/C Number</p>
                                                            <p className="text-xs font-bold text-gray-800 font-mono tracking-wider">
                                                                {personalDocs.documents.bankDetails.accountNumber}
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">IFSC Code</p>
                                                            <p className="text-xs font-bold text-gray-800 tracking-widest">{personalDocs.documents.bankDetails.ifscCode}</p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <p className="text-center py-2 text-[9px] font-bold text-blue-400 uppercase italic">Bank info not provided yet</p>
                                                )}
                                            </div>

                                            {/* Emergency Contact */}
                                            <div className="p-4 bg-rose-50/50 rounded-xl border border-rose-100">
                                                <h4 className="text-[10px] font-black uppercase text-rose-700 mb-3 tracking-widest flex items-center gap-2">
                                                    <FiUsers /> Emergency Contacts
                                                </h4>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    {[1, 2].map(num => {
                                                        const contact = personalDocs.documents?.[`emergencyContact${num}`];
                                                        return (
                                                            <div key={num} className="bg-white/60 p-3 rounded-lg border border-rose-100/50">
                                                                <p className="text-[8px] font-black text-rose-400 uppercase mb-2 tracking-widest">Contact #{num}</p>
                                                                {contact?.name ? (
                                                                    <div className="space-y-1">
                                                                        <p className="text-xs font-bold text-gray-800 uppercase">{contact.name}</p>
                                                                        <div className="flex items-center justify-between">
                                                                            <p className="text-[10px] font-bold text-gray-500 font-mono">{contact.phone}</p>
                                                                            <span className="text-[9px] font-bold text-rose-600 bg-rose-100 px-2 py-0.5 rounded uppercase">{contact.relationship}</span>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <p className="text-[9px] font-bold text-rose-300 uppercase italic">Contact {num} not provided</p>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center p-12 bg-gray-50 rounded-lg border border-dashed border-gray-200">
                                            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-gray-300">
                                                <FiAlertTriangle size={24} />
                                            </div>
                                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">No Personal documents records found</p>
                                            <p className="text-[8px] text-gray-400 mt-1 uppercase italic tracking-tighter">Candidate may not have started the document upload process yet</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="flex justify-end p-6 pt-0">
                                <button
                                    className="px-6 py-2 text-slate-500 font-bold text-xs uppercase tracking-widest hover:bg-slate-100 rounded"
                                    onClick={() => setIsDocsModalOpen(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Assessment Detail Modal */}
                {isAssessmentModalOpen && selectedAssessmentData && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                        <div className="bg-white max-w-4xl w-full rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100 max-h-[90vh] flex flex-col">
                            <div className="px-8 pt-8 pb-6 border-b border-gray-100 flex-shrink-0">
                                <div className="flex items-start justify-between">
                                    <div>
                                        <h2 className="text-xl text-gray-800 font-bold flex items-center gap-2">
                                            Assessment Answer Sheets
                                        </h2>
                                        <p className="text-[10px] font-bold uppercase tracking-widest mt-1.5 text-gray-500">
                                            Candidate: <span className="text-indigo-600">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
                                        </p>
                                    </div>
                                    <button
                                        onClick={() => setIsAssessmentModalOpen(false)}
                                        className="p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                                    >
                                        <FiX className="text-lg" />
                                    </button>
                                </div>
                            </div>

                            <div className="p-8 overflow-y-auto space-y-12 flex-grow bg-white">
                                {Array.isArray(selectedAssessmentData) && selectedAssessmentData.length > 0 ? (
                                    selectedAssessmentData.map((assessment, aIdx) => (
                                        <div key={aIdx} className="space-y-6">
                                            <div className="flex items-center justify-between pb-2 border-b-2 border-indigo-100">
                                                <h3 className="text-lg font-black text-indigo-900">{assessment.quizTitle}</h3>
                                                <div className="flex items-center gap-4">
                                                    <div className="flex items-center gap-1">
                                                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Score:</span>
                                                        <span className={`text-sm font-black ${assessment.score >= 70 ? 'text-emerald-600' : assessment.score >= 50 ? 'text-amber-600' : 'text-rose-600'}`}>
                                                            {assessment.score}
                                                        </span>
                                                    </div>
                                                    <div className="flex items-center gap-1">
                                                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Duration:</span>
                                                        <span className="text-sm font-black text-blue-600">
                                                            {assessment.quizId?.duration || 30} mins
                                                        </span>
                                                    </div>
                                                    <div className="flex items-center gap-1">
                                                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Time Taken:</span>
                                                        <span className="text-sm font-black text-indigo-600">
                                                            {(() => {
                                                                const timeVal = assessment.timeTaken !== undefined && assessment.timeTaken !== null
                                                                    ? assessment.timeTaken
                                                                    : getAssessmentTimeTaken(assessment, aIdx, selectedAssessmentData, selectedCandidate);
                                                                return formatSecondsToTime(timeVal);
                                                            })()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="space-y-6">
                                                {assessment.answers && assessment.answers.length > 0 ? (
                                                    assessment.answers.map((ans, idx) => {
                                                        const optionLabels = ["A", "B", "C", "D", "E", "F", "G", "H"];
                                                        const options = ans.options && ans.options.length > 0
                                                            ? ans.options
                                                            : [ans.selectedOption, ans.correctAnswer].filter(Boolean);

                                                        return (
                                                            <div key={idx} className="bg-white rounded-xl border border-gray-200 shadow-[0_2px_10px_-3px_rgba(6,81,237,0.1)] overflow-hidden">
                                                                <div className="flex items-start gap-3 px-5 py-4 border-b border-gray-100 bg-gray-50/50">
                                                                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 font-black text-xs ${ans.isCorrect ? 'bg-emerald-100 text-emerald-600' : 'bg-rose-100 text-rose-600'}`}>
                                                                        Q{idx + 1}
                                                                    </div>
                                                                    <div className="flex-grow pt-1">
                                                                        <p className="text-sm font-bold text-gray-800 leading-relaxed">{ans.questionText}</p>
                                                                    </div>
                                                                    <div className="shrink-0 pt-1.5 flex items-center gap-1.5">
                                                                        {ans.isCorrect ? (
                                                                            <span className="text-[10px] font-black uppercase text-emerald-600 flex items-center gap-1">✓ Correct</span>
                                                                        ) : (
                                                                            <span className="text-[10px] font-black uppercase text-rose-600 flex items-center gap-1">✗ Incorrect</span>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="p-5 space-y-2.5">
                                                                    {options.map((opt, oIdx) => {
                                                                        const isCorrectOpt = String(opt).trim() === String(ans.correctAnswer).trim();
                                                                        const isCandidateOpt = String(opt).trim() === String(ans.selectedOption).trim();
                                                                        const label = optionLabels[oIdx] || String(oIdx + 1);

                                                                        let optStyle = "bg-white border-gray-200 text-gray-600";
                                                                        let radioStyle = "border-gray-200 border-2";
                                                                        let badge = null;

                                                                        if (isCorrectOpt && isCandidateOpt) {
                                                                            optStyle = "bg-emerald-50/50 border-emerald-300 text-emerald-800";
                                                                            radioStyle = "border-emerald-500 bg-emerald-500";
                                                                            badge = <span className="text-[9px] font-black text-emerald-600 bg-emerald-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✓ Selected Correctly</span>;
                                                                        } else if (isCorrectOpt) {
                                                                            optStyle = "bg-emerald-50/30 border-emerald-200 text-emerald-700 border-dashed";
                                                                            radioStyle = "border-emerald-400 border-2";
                                                                            badge = <span className="text-[9px] font-black text-emerald-600 bg-emerald-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✓ Correct Answer</span>;
                                                                        } else if (isCandidateOpt) {
                                                                            optStyle = "bg-rose-50/50 border-rose-300 text-rose-800";
                                                                            radioStyle = "border-rose-500 bg-rose-500";
                                                                            badge = <span className="text-[9px] font-black text-rose-600 bg-rose-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✗ Selected Incorrectly</span>;
                                                                        }

                                                                        return (
                                                                            <div key={oIdx} className={`flex items-center gap-4 px-4 py-3 rounded-xl border transition-all ${optStyle}`}>
                                                                                <div className="shrink-0">
                                                                                    <span className="text-[10px] font-black text-gray-400 bg-gray-50 border border-gray-100 px-2 py-0.5 rounded uppercase">{label}</span>
                                                                                </div>
                                                                                <div className={`w-4 h-4 rounded-full flex items-center justify-center shrink-0 ${radioStyle}`}>
                                                                                    {(isCandidateOpt || isCorrectOpt) && (
                                                                                        <div className={`w-1.5 h-1.5 rounded-full ${isCorrectOpt && !isCandidateOpt ? 'bg-emerald-400' : 'bg-white'}`} />
                                                                                    )}
                                                                                </div>
                                                                                <p className="text-xs font-semibold flex-grow">{opt}</p>
                                                                                {badge && (
                                                                                    <div className="shrink-0 flex items-center justify-end min-w-[120px]">
                                                                                        {badge}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <p className="text-xs text-gray-500 italic">No detailed answers available for this assessment.</p>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-20 bg-gray-50 rounded-xl border border-gray-100 flex flex-col items-center justify-center">
                                        <div className="w-16 h-16 bg-white text-gray-300 rounded-full flex items-center justify-center mb-4 border border-gray-100 shadow-sm">
                                            <FiEye className="text-3xl" />
                                        </div>
                                        <p className="text-gray-800 font-bold mb-1">No detailed analysis available</p>
                                        <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest max-w-xs">Old assessment record without question tracking</p>
                                    </div>
                                )}
                            </div>

                            <div className="px-8 py-4 border-t border-gray-100 bg-gray-50 flex justify-end flex-shrink-0">
                                <button
                                    onClick={() => setIsAssessmentModalOpen(false)}
                                    className="px-6 py-2.5 bg-white border border-gray-200 text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-lg font-bold text-xs uppercase tracking-widest transition-all shadow-[0_2px_4px_rgba(0,0,0,0.02)]"
                                >
                                    Close View
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Salary Package Modal */}
                {isPackageModalOpen && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                        <div className="bg-white rounded-2xl max-w-2xl w-full p-6 shadow-2xl relative animate-in fade-in zoom-in duration-300">
                            <button
                                onClick={() => setIsPackageModalOpen(false)}
                                className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
                            >
                                <FiX />
                            </button>

                            <div className="text-center mb-8">
                                <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <FiBriefcase size={28} />
                                </div>
                                <h2 className="text-2xl font-black text-gray-800">Salary Package</h2>
                                <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest mt-1">Negotiation & Finalization</p>
                            </div>

                            <div className="space-y-4">
                                <div className="grid grid-cols-2 gap-4">
                                    <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                                        <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Budget Salary</p>
                                        <p className="text-sm font-bold text-gray-800">{selectedCandidate?.jobId?.salary || "N/A"}</p>
                                    </div>
                                    <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                                        <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Previous Salary</p>
                                        <p className="text-sm font-bold text-gray-800">{selectedCandidate?.currentCTC || "N/A"}</p>
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Final Agreed Salary</label>
                                        <div className="relative">
                                            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-bold">₹</div>
                                            <input
                                                type="text"
                                                placeholder="e.g. 12,00,000"
                                                className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                                value={packageSalary}
                                                onChange={(e) => setPackageSalary(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Joining Date</label>
                                        <div className="relative">
                                            <input
                                                type="date"
                                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                                value={packageJoiningDate}
                                                onChange={(e) => setPackageJoiningDate(e.target.value)}
                                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Notice Period</label>
                                        <select
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800 appearance-none"
                                            value={packageNoticePeriod}
                                            onChange={(e) => setPackageNoticePeriod(e.target.value)}
                                        >
                                            <option value="">Select Notice Period</option>
                                            <option value="10 Days">10 Days</option>
                                            <option value="15 Days">15 Days</option>
                                            <option value="20 Days">20 Days</option>
                                            <option value="30 Days">30 Days</option>
                                            <option value="60 Days">60 Days</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Probation Period</label>
                                        <input
                                            type="text"
                                            placeholder="e.g. 6 Months"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                            value={packageProbationPeriod}
                                            onChange={(e) => setPackageProbationPeriod(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Daily Allowance (Optional)</label>
                                        <input
                                            type="text"
                                            placeholder="e.g. ₹500 or NA"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                            value={packageDailyAllowance}
                                            onChange={(e) => setPackageDailyAllowance(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Perf. Allowance (Optional)</label>
                                        <input
                                            type="text"
                                            placeholder="e.g. ₹2000 or NA"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                            value={packagePerformanceAllowance}
                                            onChange={(e) => setPackagePerformanceAllowance(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <p className="text-[9px] text-gray-400 mt-1 px-1 font-medium italic">* These values will be used in the official offer letter.</p>

                                <button
                                    onClick={handleSavePackage}
                                    className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-2xl font-black text-xs uppercase tracking-[0.2em] shadow-lg shadow-blue-200 hover:shadow-blue-300 hover:-translate-y-0.5 transition-all duration-300 mt-2"
                                >
                                    Save Package Details
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Document History Modal */}
                {isHistoryModalOpen && selectedCandidate && (
                    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                        <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
                            <button
                                onClick={() => setIsHistoryModalOpen(false)}
                                className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                            >
                                <FiX className="text-lg" />
                            </button>
                            <div className="px-8 pt-8 pb-4">
                                <h2 className="text-xl text-gray-800">Document Sent History</h2>
                                <p className="text-[10px] font-bold uppercase tracking-widest mt-1">
                                    Candidate: {selectedCandidate.firstName} {selectedCandidate.lastName}
                                </p>
                            </div>
                            <div className="p-8 pt-4 max-h-[70vh] overflow-y-auto">
                                {selectedCandidate.documentHistory && selectedCandidate.documentHistory.length > 0 ? (
                                    <div className="space-y-4">
                                        {selectedCandidate.documentHistory.map((item, index) => (
                                            <div key={item._id || index} className="p-4 bg-gray-50 rounded-2xl border border-gray-100 flex items-center justify-between group hover:bg-white hover:shadow-lg transition-all duration-300">
                                                <div className="flex items-center gap-4">
                                                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-lg ${item.documentType === 'Offer' ? 'bg-green-100 text-green-600' :
                                                            item.documentType === 'Agreement' ? 'bg-blue-100 text-blue-600' :
                                                                'bg-gray-100 text-gray-600'
                                                        }`}>
                                                        <FiFileText />
                                                    </div>
                                                    <div>
                                                        <div className="flex items-center gap-2">
                                                            <span className="text-sm font-black text-gray-800 uppercase tracking-tight">{item.documentType} Letter</span>
                                                            <span className="text-[10px] font-bold text-gray-400">Sent on {new Date(item.sentAt).toLocaleDateString()} at {new Date(item.sentAt).toLocaleTimeString()}</span>
                                                        </div>
                                                        <div className="mt-1 text-xs text-gray-500 line-clamp-1 max-w-md italic">
                                                            "{item.content?.replace(/<[^>]*>?/gm, '').substring(0, 100)}..."
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    {item.attachmentPath && (
                                                        <>
                                                            <button
                                                                onClick={() => window.open(formatDocUrl(item.attachmentPath), "_blank")}
                                                                className="px-4 py-2 bg-gray-100 text-gray-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-gray-200 transition-all flex items-center gap-2"
                                                                title="View Document"
                                                            >
                                                                <FiEye size={12} /> View
                                                            </button>
                                                            <button
                                                                onClick={() => {
                                                                    const link = document.createElement('a');
                                                                    link.href = formatDocUrl(item.attachmentPath);
                                                                    link.download = `${item.documentType}_Letter.pdf`;
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                }}
                                                                className="px-4 py-2 bg-emerald-50 text-emerald-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-emerald-100 transition-all flex items-center gap-2"
                                                                title="Download Document"
                                                            >
                                                                <FiDownload size={12} /> Download
                                                            </button>
                                                        </>
                                                    )}
                                                    <button
                                                        disabled={historyLoading}
                                                        onClick={() => handleDeleteHistoryItem(item._id)}
                                                        className="p-2 text-rose-400 hover:text-rose-600 hover:bg-rose-50 rounded-xl transition-all"
                                                        title="Delete History Entry"
                                                    >
                                                        <FiTrash2 size={14} />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center py-20 bg-gray-50 rounded-3xl border border-dashed border-gray-200">
                                        <div className="w-16 h-16 bg-white text-gray-300 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
                                            <FiClock size={32} />
                                        </div>
                                        <h3 className="text-lg font-black text-gray-800 uppercase tracking-tight">No history found</h3>
                                        <p className="text-xs text-gray-400 font-bold uppercase tracking-widest mt-1">No documents have been sent to this candidate yet.</p>
                                    </div>
                                )}
                            </div>
                            <div className="p-6 bg-gray-50 border-t border-gray-100 flex justify-end">
                                <button
                                    onClick={() => setIsHistoryModalOpen(false)}
                                    className="px-8 py-2 bg-white text-gray-700 border border-gray-200 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-50 transition-all shadow-sm"
                                >
                                    Close History
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
};

export default Score;